// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-09T16:38:00.765Z
// Property: Onyx Winter Park (ID: 5712947535937536)
// Collections: 22 amenities, 6 floorplans (live), 25 photos, 82 POIs, 5 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5712947535937536",
  "property_external_id": "4680438",
  "property_zillow_url": "https://www.zillow.com/apartments/casselberry-fl/reflections/5hJ2zk/",
  "property_apartments_url": "https://www.apartments.com/onyx-winter-park-casselberry-fl/8wekhe1",
  "property_google_business_url": "https://www.google.com/maps/place/Onyx+Winter+Park/@28.6311182,-81.3175164,18z/data=!4m13!1m7!3m6!1s0x88e76e4a668830bb:0x7000d6592fa02529!2s100+Reflections+Cir,+Casselberry,+FL+32707!3b1!8m2!3d28.6308623!4d-81.316217!3m4!1s0x88e76e4a5137cfd1:0x6aaa91ca73a20b3c!8m2!3d28.6308623!4d-81.316217",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443838466",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "onyx-winter-park",
  "property_name": "Onyx Winter Park",
  "property_website_url": "https://www.onyxwinterpark.com/",
  "property_domain": "https://www.onyxwinterpark.com/",
  "property_address": "100 Reflections Cir",
  "property_full_address": "100 Reflections Cir, Casselberry, FL 32707",
  "property_address_1": "100 Reflections Cir",
  "property_address_2": null,
  "property_address_city": "Casselberry",
  "property_address_state": "FL",
  "property_address_zip_full": "32707-6621",
  "property_address_zip": "32707",
  "property_address_country": "US",
  "property_address_county": "Seminole County",
  "property_neighborhood_address": "Lake Howell",
  "property_address_latitude": "28.6304456",
  "property_address_longitude": "-81.31722719999999",
  "property_email": "onyx@alapts.com",
  "property_phone": "(407) 678-7555",
  "property_call_tracking_phone": "352-320-4478",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Lake Howell calm, Winter Park energy.</strong> Discover garden-style studio, one-, and two-bedroom apartments with modern finishes, select lake views, and resort-inspired everyday spaces—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Onyx Winter Park for yourself.</p>",
  "property_long_description": "<p><strong>Lake Howell living with Winter Park energy close by.</strong> At Onyx Winter Park, you can settle into garden-style apartments in Casselberry with the calm of lakefront surroundings and quick access to Semoran Boulevard, FL-417, Full Sail University, and the shops, cafés, and restaurants of Park Avenue and Winter Park Village.</p><p>Choose from studio, one-, and two-bedroom <a href=\"/floor-plans\">floor plans</a> with modern touches such as stainless-steel appliances, shaker-style cabinets, decorative tile backsplashes, wood-style flooring, screened patios or balconies, fireplaces, in-home laundry, and lake views available in select homes. Around the community, <a href=\"/amenities\">everyday amenities</a> add resort-inspired ease, including a swimming pool, 24-hour fitness center, clubhouse, internet café, package lockers, grills and picnic space, an onsite dog park, and pet spa.</p><p>When you want to get out, explore Red Bug Lake Park, Lake Concord Park, Casselberry Commons, local dining along Aloma and Howell Branch, and the broader <a href=\"/neighborhood\">Winter Park area</a> just minutes from home.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019d02f2-20a3-72ba-85fc-7e7dbe7cb1ef.webp",
  "property_featured_image_media": {
    "alt_text": "Living room and dining area with neutral-toned furniture and modern art.",
    "public_id": "019d02f2-20a3-72ba-85fc-7e7dbe7cb1ef",
    "storage_key": "property/5712947535937536/019d02f2-20a3-72ba-85fc-7e7dbe7cb1ef.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "336",
  "property_year_built": "1983",
  "property_year_renovated": "2020",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "99.70238095238095",
  "property_admin_fee": "200",
  "property_application_fee": "80",
  "property_fees_deposit_info": "Application Fee $80\nAdministrative Fee $200\nNon-Refundable Pet Fee $350 / pet\nMonthly Pet Rent $30 / pet\nApplication Approval Fee Starting At $399\n",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8305509.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://onyxwinterpark.loftliving.com/login",
  "property_apply_now_url": "https://8305509.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019d02f1-4904-74ad-9730-51da0da77d81.webp",
  "property_primary_logo_media": {
    "alt_text": "Onyx Winter Park Premier Apartments logo",
    "public_id": "019d02f1-4904-74ad-9730-51da0da77d81",
    "storage_key": "property/5712947535937536/019d02f1-4904-74ad-9730-51da0da77d81.webp",
    "width": 1467,
    "height": 594
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e6ff9-be03-722c-9dad-c93f1def5d3f.webp",
  "property_secondary_logo_media": {
    "alt_text": "Onyx logo",
    "public_id": "019e6ff9-be03-722c-9dad-c93f1def5d3f",
    "storage_key": "property/5712947535937536/019e6ff9-be03-722c-9dad-c93f1def5d3f.webp",
    "width": 1467,
    "height": 594
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e6ff9-bf33-70ea-9408-d8e59fa5b19e.webp",
  "property_icon_media": {
    "alt_text": "Onyx logo in blue on a black background.",
    "public_id": "019e6ff9-bf33-70ea-9408-d8e59fa5b19e",
    "storage_key": "property/5712947535937536/019e6ff9-bf33-70ea-9408-d8e59fa5b19e.webp",
    "width": 1611,
    "height": 1611
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e6ff9-bf33-70ea-9408-d8e59fa5b19e.webp",
  "property_fav_icon_media": {
    "alt_text": "Onyx logo in blue on a black background.",
    "public_id": "019e6ff9-bf33-70ea-9408-d8e59fa5b19e",
    "storage_key": "property/5712947535937536/019e6ff9-bf33-70ea-9408-d8e59fa5b19e.webp",
    "width": 1611,
    "height": 1611
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f4314-2937-743c-bd15-e27973fbef45.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f4314-2937-743c-bd15-e27973fbef45",
    "storage_key": "property/5712947535937536/019f4314-2937-743c-bd15-e27973fbef45.webp",
    "width": 1280,
    "height": 518
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f4314-1d95-759b-a460-4d3222c805da.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f4314-1d95-759b-a460-4d3222c805da",
    "storage_key": "property/5712947535937536/019f4314-1d95-759b-a460-4d3222c805da.webp",
    "width": 1280,
    "height": 518
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#0081bb",
  "property_secondary_color": "#015e88",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#666666",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "460 - 998",
  "property_sqft_min": "460",
  "property_sqft_max": "998",
  "property_price_range": "1232 - 1860",
  "property_price_min": "1232",
  "property_price_max": "1860",
  "property_available_units": 1,
  "property_facebook_url": "https://www.facebook.com/OnyxWinterPark",
  "property_instagram_url": "https://www.instagram.com/onyxwinterpark",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ0c83UUpu54gRPAuic8qRqmo",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/reflections-apartments-casselberry-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Everyday ease, plus standout spaces.</strong> At Onyx Winter Park, amenities keep the day moving with a 24-hour fitness center, pool, clubhouse, internet café, outdoor grilling, package lockers, and covered parking options. Pet-friendly perks include a bark park and pet spa, while select apartments add screened patios or balconies, lake views, fireplaces, wood-style flooring, in-home laundry, and polished kitchens with stainless-steel appliances and tile backsplashes.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find a layout that lives well.</strong> Onyx Winter Park offers studio, one-bedroom, and two-bedroom apartments with open living areas, natural light, and smart use of space. Select homes add stainless-steel appliances, shaker-style cabinets, decorative tile backsplashes, wood-style flooring, walk-in closets, screened patios or balconies, fireplaces, in-home laundry, and lake views. Compare featured floor plans, check availability, and choose the space that fits your day.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life by Lake Howell.</strong> Preview bright interiors with sliding glass doors, stainless-steel appliances, and shaker-style cabinetry, then look outside to the pool deck, picnic areas, grills, and dock along the water. The gallery also captures the clubhouse, fitness center, laundry spaces, and pet spa—just enough to make “View All Photos” your next click.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Lake Howell views, Casselberry convenience.</strong> Onyx Winter Park puts scenic shoreline moments close to home with Semoran Boulevard nearby for dining, errands, and Orlando-area connections. Grab local flavor along SR 436, head toward Aloma and Howell Branch for cafés and shops, or get outside on Cady Way Trail and at Lake Concord Park with public art, gardens, a boardwalk, and community events.</p>",
  "property_home_reviews_blurb": "<p><strong>Resident reviews point to everyday ease at Onyx Winter Park.</strong> Feedback often highlights comfortable apartments, modern finishes, a peaceful setting, and a team known for being helpful and responsive. From prompt maintenance to screened porches, private patios, clean grounds, resident events, and welcoming community spaces, the details add up to what one resident calls a “real sense of home and community.”</p>",
  "property_neighborhood_blurb": "<p><strong>Start with the lake, then follow the neighborhood in every direction.</strong> From Onyx Winter Park, Lake Howell gives your day a scenic Casselberry backdrop while Semoran Boulevard keeps errands, dining, and Orlando-area connections simple. Pick up dinner around the SR 436 corridor—local favorites like Kai Asian Street Fare and Donut King sit close to home—or head toward Aloma and Howell Branch for more cafés, shops, and everyday stops.</p><p>When you want fresh air, the area opens up beyond the shoreline: Cady Way Trail connects Winter Park and Orlando by paved path, and Casselberry’s Lake Concord Park brings public art, gardens, a boardwalk, and community events into the mix. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how this Lake Howell location fits your routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity spaces that work as hard as your home does.</strong> At Onyx Winter Park, your routine can move from a 24-hour fitness center to the pool, clubhouse, internet café, or an outdoor grill area without leaving the community. Package lockers, online resident services, covered parking options, and 24-hour laundry support the practical side of the day, while the bark park and pet spa add thoughtful convenience for four-legged companions. Explore more pet-friendly details on the <a href=\"/pet-policy\">pet policy</a>.</p><p>Inside select apartments, screened patios or balconies, lake views, fireplaces, wood-style flooring, in-home laundry, and polished kitchens with stainless-steel appliances, shaker-style cabinets, and decorative tile backsplashes bring extra comfort to your space. Browse the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the amenities up close.</p>",
  "property_applynow_blurb": "<p><strong>Ready for Lake Howell living?</strong> Start your online application for Onyx Winter Park and choose a garden-style studio, one-, or two-bedroom apartment with modern finishes, screened outdoor space, and select lake views—plus resort-inspired community spaces that make everyday life feel easy.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact the leasing team at Onyx Winter Park for help exploring lakefront garden-style apartments in Casselberry, available studio, one-, and two-bedroom layouts, and the everyday conveniences that make getting settled simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Onyx Winter Park?</strong> Start here for quick answers about the community, leasing, amenities, and everyday living in our Casselberry apartments near Lake Howell. If you need anything else, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Compare layouts that match the way you move through your day.</strong> At Onyx Winter Park, you can choose from efficient studio apartments, comfortable one-bedroom homes, and two-bedroom floor plans with one or two baths. Each option is designed to make the most of your space, with open living areas, natural light, and room to settle into your own routine.</p><p>Look for details that make the floor plan feel finished from the start, including stainless-steel appliances, shaker-style cabinets, decorative tile backsplashes, walk-in closets, and wood-style flooring in select homes. Screened patios or balconies, fireplaces, in-home laundry, and lake views are also available in select layouts. Browse current availability, compare pricing, then explore more <a href=\"/amenities\">apartment features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite floor plan in person.</p>",
  "property_gallery_blurb": "<p><strong>See Onyx Winter Park from every angle.</strong> Browse photos of sunlit living rooms with sliding glass doors, kitchens with stainless-steel appliances and shaker-style cabinetry, and bedrooms with a clean, comfortable look. Outside, the gallery moves from the pool deck with lounge seating to lakefront picnic spots, community grills, and a dock stretching toward Lake Howell. You’ll also see the spaces that make the community feel complete: a clubhouse with game tables, a bright fitness center, laundry spaces, and pet-friendly touches like the pet spa. When a photo catches your eye, explore the <a href=\"/amenities\">amenities</a>, compare <a href=\"/floor-plans\">floor plans</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Lake Howell living on the map.</strong> Browse available apartments at Onyx Winter Park, then zoom out to see how Casselberry’s lakefront calm connects with Semoran Boulevard, FL-417, Winter Park shops and dining, nearby parks, and local everyday stops.</p>",
  "property_pets_blurb": "<p><strong>Bring the leash, the treats, and the daily routine.</strong> At Onyx Winter Park, cats and dogs are welcome, with up to two pets per home and no weight limit, so your space can fit the way you live with your companions. Between the onsite bark park, pet spa, and open-air community areas, it is easy to build walks, rinse-offs, and playtime into your day without making a separate trip.</p><p>Inside, select homes add pet-friendly breathing room with screened patios or balconies, wood-style flooring, and lake views that make quiet mornings feel a little more relaxed. When you want more room to roam, Casselberry’s shaded Pawmosa Dog Park is nearby. Explore the <a href=\"/amenities\">pet-friendly amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Onyx Winter Park works for you and your pets.</p>",
  "property_referafriend_blurb": "<p><strong>Share Lake Howell living.</strong> Love the lakefront calm, garden-style apartments, and Winter Park energy nearby? Invite a friend to discover Onyx Winter Park, from modern <a href=\"/floor-plans\">floor plans</a> to resort-inspired <a href=\"/amenities\">amenities</a>, and let them see what makes home here worth sharing.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made simple.</strong><br>Log in to manage life at Onyx Winter Park—from paying rent to submitting maintenance requests and updating your account—so you can get back to enjoying lakefront calm, garden-style comfort, and Winter Park energy close by.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback, real reasons to feel confident.</strong> As you browse reviews for Onyx Winter Park, you’ll see residents consistently praise the comfortable apartments, modern finishes, peaceful setting, and helpful team.</p><p>Many highlight quick maintenance, responsive leasing support, and thoughtful touches like screened porches, private patios, clean grounds, resident events, and inviting community spaces. One resident sums it up as a “real sense of home and community,” while others call out the staff’s attentiveness and the ease of getting service requests handled promptly.</p>",
  "property_created_at": "1752256586957",
  "property_scheduletour_blurb": "<p><strong>See Lake Howell living up close.</strong> Tour Onyx Winter Park and picture the details in person—from garden-style layouts and modern finishes to screened outdoor space and lake views in select homes. Explore available <a href=\"/floor-plans\">floor plans</a>, then schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will be in touch soon. In the meantime, picture lakefront calm, garden-style apartments, modern finishes, and resort-inspired amenities—all with Winter Park energy close by at Onyx Winter Park.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside Onyx Winter Park before you visit.</strong> Use the virtual tours to move room by room through apartment interiors, compare a one-bedroom layout with a two-bedroom, and get a better feel for finishes like shaker-style cabinetry, stainless-steel appliances, wood-style flooring, and bright living areas with outdoor access. Then explore the community tour, clubhouse, 24-hour fitness center, and pet spa to see how daily spaces come together in Casselberry. Start online, browse the <a href=\"/floor-plans\">floor plans</a> that match what you liked, then <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see Onyx Winter Park in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Onyx Winter Park",
  "property_seo_title_home": "Onyx Winter Park | Apartments in Casselberry, FL",
  "property_seo_description_home": "Elevate your lifestyle at Onyx Winter Park in Casselberry, FL. Choose from spacious studio, one, and two-bedroom floor plans with stunning lake views and modern amenities. Enjoy exclusive features like our LUXER Package Locker, a relaxing dog park, and a state-of-the-art fitness center. Unwind at the clubhouse or take a dip in the pool. With online resident services and a pet spa, convenience meets comfort. Your ideal living space awaits—find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | studio - 2 Apartments in Casselberry, FL",
  "property_seo_description_floorplans": "Unveiling the stylish living options at Onyx Winter Park in Casselberry, FL! From cozy studios to spacious two-bedrooms, our diverse floor plans cater to your lifestyle needs. Each apartment is designed with modern finishes and thoughtful layouts to ensure comfort and convenience. Browse our available homes today and envision your future in a space that truly reflects your taste!",
  "property_seo_title_amenities": "Amenities | Casselberry, FL Apartments for Rent",
  "property_seo_description_amenities": "Elevate your living experience at Onyx Winter Park in Casselberry, FL. Our thoughtfully designed floor plans offer studio, one, and two-bedroom options, complemented by a suite of exceptional amenities. Unwind in the refreshing pool, enjoy serene lake views, or energize at our fitness center. With features like a pet spa, dog park, and a welcoming clubhouse, every detail enhances your lifestyle. Discover what makes our community unique—where comfort meets convenience, and your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Casselberry, FL",
  "property_seo_description_gallery": "\"Immerse yourself in luxury at Onyx Winter Park, where stylish studio, one, and two-bedroom apartments redefine comfort. With desirable amenities like a refreshing pool, scenic lake views, and a vibrant dog park, our community in Casselberry, FL, invites you to embrace the lifestyle you deserve. Picture yourself here, surrounded by modern design, on-site conveniences, and a clubhouse perfect for socializing. View our stunning photo gallery and envision your new home! 🏡\"",
  "property_seo_title_virtualtours": "Virtual Tours | Onyx Winter Park Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Onyx Winter Park in Casselberry, FL, where modern floor plans meet exceptional amenities. From cozy studios to spacious two-bedroom apartments, our community offers the perfect home for every lifestyle. Immerse yourself in the ambiance of your future home—take a virtual tour today and envision your new beginning!",
  "property_seo_title_interactivemap": "Interactive Map | Onyx Winter Park Apartments",
  "property_seo_description_interactivemap": "Uncover your ideal apartment at Onyx Winter Park in Casselberry, FL, where luxury meets comfort. From charming studios to spacious two-bedroom homes, our community boasts top-tier amenities like a refreshing pool, state-of-the-art fitness center, and dog park for your furry friends. Enjoy breathtaking lake views, convenient online resident services, and a vibrant clubhouse—perfect for relaxation and socializing. Ready to find your next home? Use our interactive community map to view available apartments and pricing today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Casselberry, FL",
  "property_seo_description_neighborhood": "Experience the charm of Casselberry, FL, as you immerse yourself in the vibrant neighborhood surrounding Onyx Winter Park. From cozy cafes to lush parks, our community is perfectly situated near local favorites and hidden gems. Let your next adventure begin right outside your door—uncover the delights that await just steps from our stylish studio, one-bedroom, and two-bedroom apartments!",
  "property_seo_title_contact": "Contact Us | Onyx Winter Park",
  "property_seo_description_contact": "Connect with the leasing team at Onyx Winter Park in Casselberry, FL! Whether you’re interested in our stylish studios, inviting one-bedroom, or spacious two-bedroom floor plans, we’re here to help you find your perfect home. Have questions? Let’s chat today!",
  "property_seo_title_faqs": "FAQs | Apartments in Casselberry, FL",
  "property_seo_description_faqs": "Unveil the answers to your burning questions about Onyx Winter Park, the premier apartment community nestled in Casselberry, FL. From stylish studio apartments to spacious two-bedroom layouts, discover the benefits of our exceptional amenities like a state-of-the-art fitness center, refreshing pool, and a serene dog park. Whether you’re curious about lake views, laundry facilities, or online resident services, our FAQs page is your go-to resource for everything you need to know. Get informed and find your perfect home today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Casselberry, FL",
  "property_seo_description_reviews": "Experience the vibrant lifestyle at Onyx Winter Park in Casselberry, FL, where modern living meets exceptional amenities. From spacious studios to expansive two-bedroom floor plans, each home offers stunning lake views, stylish finishes, and convenient features like in-unit laundry. Our community boasts resort-style living with a pool, dog park, fitness center, and more. Curious about what life is like here? Hear directly from our residents and see why Onyx Winter Park is the perfect place to call home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Casselberry, FL",
  "property_seo_description_applynow": "Unveil your ideal living space at Onyx Winter Park in Casselberry, FL. Choose from thoughtfully designed studio, one-, and two-bedroom floor plans, each boasting modern amenities like a fitness center, clubhouse, and pet spa. Enjoy the tranquility of lake views from select homes, alongside perks like covered parking, a grill area, and a vibrant playground. With our online resident services and LUXER Package Locker, convenience meets comfort. Ready to elevate your lifestyle? Join our community and lease your new home online today!",
  "property_seo_title_residentaccess": "Resident Access | Onyx Winter Park",
  "property_seo_description_residentaccess": "Unlock the convenience of life at Onyx Winter Park! Log in to your resident portal for seamless rent payments, hassle-free maintenance requests, and an array of community resources—all at your fingertips. Your comfortable living experience in Casselberry awaits!",
  "property_seo_title_referafriend": "Refer A Friend | Onyx Winter Park",
  "property_seo_description_referafriend": "\"At Onyx Winter Park in Casselberry, FL, great friends make great neighbors! Share the joy of luxurious living by referring a friend today and unlock exclusive rewards. Your cozy community awaits!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Onyx Winter Park",
  "property_seo_description_scheduletour": "\"Step into a world of modern elegance at Onyx Winter Park in Casselberry, FL. Experience stylish living with top-notch amenities, serene surroundings, and a vibrant community. Ready to see your future home? Schedule a tour today!\"",
  "property_seo_title_privacy": "Privacy Policy | Onyx Winter Park",
  "property_seo_description_privacy": "\"At Onyx Winter Park in Casselberry, FL, your peace of mind is our priority. Dive into our Privacy Policy to learn how we safeguard your privacy while you enjoy your vibrant living experience. Transparency matters—get the details today!\"",
  "property_seo_title_accessibility": "Website Accessibility | Onyx Winter Park",
  "property_seo_description_accessibility": "At Onyx Winter Park in Casselberry, FL, we prioritize accessibility for all residents and visitors. Our commitment to digital inclusion ensures everyone can navigate our community with ease. Join us in creating a welcoming environment where everyone belongs. Learn more about our initiatives today!",
  "property_seo_title_sitemap": "Sitemap | Onyx Winter Park",
  "property_seo_description_sitemap": "\"Unravel the full experience of Onyx Winter Park in Casselberry, FL! Navigate effortlessly through our sitemap to uncover unique amenities, vibrant community events, and your future dream apartment. Your ideal living space awaits!\"",
  "property_seo_title_thankyou": "Thank You | Onyx Winter Park",
  "property_seo_description_thankyou": "Thank you for reaching out to Onyx Winter Park! Your inquiry is the first step toward a vibrant lifestyle in Casselberry. Stay tuned as our team prepares to connect you with your future home that combines comfort, style, and community. Your journey to refined living awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in Austell, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320106",
  "amenities": [
    {
      "id": "custom_b89147e6-f360-456e-8a12-e00c76faaec0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "State-of-the-Art Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0b703015-5c3a-4736-87a6-0ce59082f21b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0c14f42c-86f0-428c-afd6-b697c652071f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Shaker-Style Cabinets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_012d351d-7c1f-47bc-a6cb-ff0240605019",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000000614",
      "title": "Clubhouse",
      "amount": "0.0000",
      "description": "Resident Clubhouse",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9c441397-e332-4583-8f40-c687088ba4f3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000000623",
      "title": "Covered Parking",
      "amount": "0.0000",
      "description": "Covered Parking Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_556d2aef-d766-4a18-bcbc-ccdb679f68ce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c3bf5f14-fcd6-4a9b-ba8d-85d342445b25",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000000633",
      "title": "Fire",
      "amount": "0.0000",
      "description": "Fireplace*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aab810ba-889a-42a4-b8da-6d1f10ec0cb7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "State-of-the-Art 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eded26c5-4ab0-4382-9020-5d30a4362ac7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Community Grills & Picnic Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0367032d-59e0-4cac-bfe5-a9defafc409f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style Flooring*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_17d2c6be-2e17-4163-b691-692a53ed5bd3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless-Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_af54d2c7-6d5e-4b82-b0ab-cba0db27d06c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000000654",
      "title": "Lake Views",
      "amount": "0.0000",
      "description": "Beautiful Lake Views Available*",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e557d788-e6cd-4daa-9bc5-b6f5c1b31f75",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000000656",
      "title": "Laundry Rooms",
      "amount": "0.0000",
      "description": "24-Hour Laundry Facility",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a236d872-54db-480e-9a1c-7b48a5edbdb3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cdca3f22-63ac-46ca-99bd-2b2f539dae7c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Screened Patio or Balcony*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dd58f5f3-8be1-4e7f-a0b4-426dfcd2fabc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000000668",
      "title": "Playground",
      "amount": "0.0000",
      "description": "Playground",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f8aa410f-f862-423b-9a63-203772d26cf0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Swimming Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_216ccc6f-03b2-4108-a089-463a3b0320a8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_81c56058-afb4-4e60-8e97-c035cbb18084",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5a33801e-9f28-4280-84ac-04fde53488a8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer& Dryer*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0aa58403-287b-4f30-a0cd-424f64fff6ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000002384",
      "title": "Cyber Cafe",
      "amount": "0.0000",
      "description": "Internet Cafe",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_72895665-a5d5-4747-a743-2ee785fa65b4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "external_id": "P000002472",
      "title": "Pet Spa",
      "amount": "0.0000",
      "description": "Pet Spa",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_e89855b5-d30e-4eb4-883d-2564f01e53b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-4492-73e9-bd7d-071fc4ec05a8.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e89a6-4492-73e9-bd7d-071fc4ec05a8",
        "storage_key": "property/5712947535937536/019e89a6-4492-73e9-bd7d-071fc4ec05a8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge seating.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fb8ea964-ff5d-46f1-afb0-b6edb195e9ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-455f-742b-9b36-e36b2bb0b893.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and grey countertops.",
        "public_id": "019e89a6-455f-742b-9b36-e36b2bb0b893",
        "storage_key": "property/5712947535937536/019e89a6-455f-742b-9b36-e36b2bb0b893.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this bright and modern kitchen featuring ample cabinet space, sleek grey countertops, and stainless steel appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and grey countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_02f11489-0d6f-42f9-9af4-6a95527a0df7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-2eba-7529-83aa-2e1895698030.webp",
      "image_media": {
        "alt_text": "A nicely decorated bedroom with a large bed, bedside tables, and abstract art on the wall.",
        "public_id": "019e89a6-2eba-7529-83aa-2e1895698030",
        "storage_key": "property/5712947535937536/019e89a6-2eba-7529-83aa-2e1895698030.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom. A king-sized bed with plush linens and decorative pillows ensures a restful night's sleep. Modern art and stylish decor complete the serene ambiance.",
      "link": "",
      "alt_text": "A nicely decorated bedroom with a large bed, bedside tables, and abstract art on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cedcdc74-883a-49cf-97c9-e3689f1d0145",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-2ed2-711f-9e56-15021971a50d.webp",
      "image_media": {
        "alt_text": "Community kitchen with bar seating, coffee maker, and a dining area in the background.",
        "public_id": "019e89a6-2ed2-711f-9e56-15021971a50d",
        "storage_key": "property/5712947535937536/019e89a6-2ed2-711f-9e56-15021971a50d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our modern community kitchen, perfect for gatherings, featuring a coffee maker and comfortable bar seating. A nearby dining area offers additional space.",
      "link": "",
      "alt_text": "Community kitchen with bar seating, coffee maker, and a dining area in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b3c02a3b-6c4d-49d1-a991-8d8a0f80cfe4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-3ab3-720c-8c8a-f6d1f85ea3c2.webp",
      "image_media": {
        "alt_text": "Modern bathroom with dual vanity, ample counter space, and linen closet.",
        "public_id": "019e89a6-3ab3-720c-8c8a-f6d1f85ea3c2",
        "storage_key": "property/5712947535937536/019e89a6-3ab3-720c-8c8a-f6d1f85ea3c2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and spacious bathroom featuring a contemporary dual vanity with clean white cabinetry and a large mirror. Includes a convenient linen closet with shelving for storage.",
      "link": "",
      "alt_text": "Modern bathroom with dual vanity, ample counter space, and linen closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fb6d0c9b-88ee-432c-9eac-155af1024005",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-2bb0-71ae-bb7a-62c0c74eecff.webp",
      "image_media": {
        "alt_text": "Outdoor deck with tables, chairs, lounge chairs, umbrellas, and cornhole overlooking a lake with apartment buildings in the background.",
        "public_id": "019e89a6-2bb0-71ae-bb7a-62c0c74eecff",
        "storage_key": "property/5712947535937536/019e89a6-2bb0-71ae-bb7a-62c0c74eecff.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax on the spacious outdoor deck, complete with comfortable seating, dining areas, and recreational games, all overlooking a serene lake.",
      "link": "",
      "alt_text": "Outdoor deck with tables, chairs, lounge chairs, umbrellas, and cornhole overlooking a lake with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cb16369f-e195-4e44-9a30-10d4a8a70cbe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-2614-7071-8052-bc6bd9e3eb76.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, ottoman, fireplace, and abstract art.",
        "public_id": "019e89a6-2614-7071-8052-bc6bd9e3eb76",
        "storage_key": "property/5712947535937536/019e89a6-2614-7071-8052-bc6bd9e3eb76.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa and armchair, a decorative ottoman, a cozy fireplace, and modern abstract art, perfect for relaxation.",
      "link": "",
      "alt_text": "Living room with a sofa, armchair, ottoman, fireplace, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_428cea7c-331b-44aa-9f6a-e6a55c4d1a1e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-2f92-70c5-8632-630c2754a8ae.webp",
      "image_media": {
        "alt_text": "Picnic table by a lake at an apartment complex.",
        "public_id": "019e89a6-2f92-70c5-8632-630c2754a8ae",
        "storage_key": "property/5712947535937536/019e89a6-2f92-70c5-8632-630c2754a8ae.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy an outdoor meal with a view of the lake and surrounding apartment buildings.",
      "link": "",
      "alt_text": "Picnic table by a lake at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ba420158-54d7-4bbf-a2ac-9d41b077e0d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-230b-7099-bb57-2744403cc022.webp",
      "image_media": {
        "alt_text": "Pet grooming station with a ramp and a stainless steel grooming table.",
        "public_id": "019e89a6-230b-7099-bb57-2744403cc022",
        "storage_key": "property/5712947535937536/019e89a6-230b-7099-bb57-2744403cc022.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Groom your furry friend at our on-site pet grooming station, complete with a convenient ramp and a sturdy stainless steel grooming table.",
      "link": "",
      "alt_text": "Pet grooming station with a ramp and a stainless steel grooming table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8af7db43-c421-4aaa-927f-3ef944d0e433",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-200b-736e-9975-7e75aa73d620.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and chairs next to a modern kitchen.",
        "public_id": "019e89a6-200b-736e-9975-7e75aa73d620",
        "storage_key": "property/5712947535937536/019e89a6-200b-736e-9975-7e75aa73d620.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your meals in this stylish dining area, adjacent to a fully equipped, modern kitchen featuring stainless steel appliances and ample cabinet space.",
      "link": "",
      "alt_text": "Dining area with a round table and chairs next to a modern kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c384c0f6-2df8-4de1-ad6f-eb65ce5fbc5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-27a9-7184-bfe2-2b878d407ab6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large sink.",
        "public_id": "019e89a6-27a9-7184-bfe2-2b878d407ab6",
        "storage_key": "property/5712947535937536/019e89a6-27a9-7184-bfe2-2b878d407ab6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this spacious kitchen featuring stainless steel appliances, ample cabinet space, and a deep sink. Perfect for your culinary adventures.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cdec051d-1550-4e58-b05b-93e7cb83fe04",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-2239-74ef-8b45-102fd1938c6c.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with dual sinks, modern white cabinetry, and grey countertops.",
        "public_id": "019e89a6-2239-74ef-8b45-102fd1938c6c",
        "storage_key": "property/5712947535937536/019e89a6-2239-74ef-8b45-102fd1938c6c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a spacious vanity with ample storage, sleek grey countertops, and a large mirror. Designed for comfort and style.",
      "link": "",
      "alt_text": "Bathroom vanity with dual sinks, modern white cabinetry, and grey countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_559f63ea-873c-4728-b4db-7c6253b5c958",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-229f-765a-9512-4858e9700bf5.webp",
      "image_media": {
        "alt_text": "Game room with pool table, shuffleboard, and foosball.",
        "public_id": "019e89a6-229f-765a-9512-4858e9700bf5",
        "storage_key": "property/5712947535937536/019e89a6-229f-765a-9512-4858e9700bf5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a variety of games in our spacious game room, featuring a pool table, shuffleboard, and foosball table.",
      "link": "",
      "alt_text": "Game room with pool table, shuffleboard, and foosball.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_00550e38-555d-4ba8-bd47-7ba80bbab92e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-0d3d-72fe-bcd7-54fef9448bd7.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines and weight equipment.",
        "public_id": "019e89a6-0d3d-72fe-bcd7-54fef9448bd7",
        "storage_key": "property/5712947535937536/019e89a6-0d3d-72fe-bcd7-54fef9448bd7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring a variety of cardio machines and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with cardio machines and weight equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_75dc1ddf-3bf9-4306-a886-c1d9a81ca656",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-15bb-740b-8853-d896a19f9487.webp",
      "image_media": {
        "alt_text": "Living room and dining area with modern decor.",
        "public_id": "019e89a6-15bb-740b-8853-d896a19f9487",
        "storage_key": "property/5712947535937536/019e89a6-15bb-740b-8853-d896a19f9487.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with contemporary furnishings, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room and dining area with modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e5a2d0de-4080-40bc-89a1-7dbf709b4281",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-0df5-7253-aac4-a09fd659a309.webp",
      "image_media": {
        "alt_text": "A primary bedroom with a king-sized bed, plush carpet, and abstract wall art.",
        "public_id": "019e89a6-0df5-7253-aac4-a09fd659a309",
        "storage_key": "property/5712947535937536/019e89a6-0df5-7253-aac4-a09fd659a309.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed primary bedroom, featuring a king-sized bed and elegant decor.",
      "link": "",
      "alt_text": "A primary bedroom with a king-sized bed, plush carpet, and abstract wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_254022f5-a09b-41b8-b84d-7b5d3667f399",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-1159-7714-98d3-25cbf0daedf2.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e89a6-1159-7714-98d3-25cbf0daedf2",
        "storage_key": "property/5712947535937536/019e89a6-1159-7714-98d3-25cbf0daedf2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by comfortable lounge chairs and shady umbrellas. Perfect for a sunny afternoon.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ae1dacca-190d-4ab0-a25e-f1121a2fb5da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-0543-715e-abf5-d355a0dbd23c.webp",
      "image_media": {
        "alt_text": "Onyx Winter Park Premier Apartments monument sign and entrance",
        "public_id": "019e89a6-0543-715e-abf5-d355a0dbd23c",
        "storage_key": "property/5712947535937536/019e89a6-0543-715e-abf5-d355a0dbd23c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Onyx Winter Park Premier Apartments, featuring a prominent monument sign at the entrance with lush landscaping.",
      "link": "",
      "alt_text": "Onyx Winter Park Premier Apartments monument sign and entrance",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b36497ac-cb23-4158-ad38-2a7700d623b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-05c3-73ea-b7a1-562c9f8fd77b.webp",
      "image_media": {
        "alt_text": "Screened-in porch with a small table and chairs, featuring a pineapple pillow and a decorative fish.",
        "public_id": "019e89a6-05c3-73ea-b7a1-562c9f8fd77b",
        "storage_key": "property/5712947535937536/019e89a6-05c3-73ea-b7a1-562c9f8fd77b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening breeze on the charming screened-in porch, complete with comfortable seating and a touch of coastal decor.",
      "link": "",
      "alt_text": "Screened-in porch with a small table and chairs, featuring a pineapple pillow and a decorative fish.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5cac4927-7337-44f7-821e-903b56a0002a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-0601-75af-bf5e-30ae796a3866.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and waste station",
        "public_id": "019e89a6-0601-75af-bf5e-30ae796a3866",
        "storage_key": "property/5712947535937536/019e89a6-0601-75af-bf5e-30ae796a3866.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, complete with agility equipment for your furry friends and a convenient waste station.",
      "link": "",
      "alt_text": "Dog park with agility equipment and waste station",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b5c26b7a-3a69-4dc6-bdfd-43c9b9835ecc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-054f-75ae-98fc-cc83e683cc40.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and stationary bikes.",
        "public_id": "019e89a6-054f-75ae-98fc-cc83e683cc40",
        "storage_key": "property/5712947535937536/019e89a6-054f-75ae-98fc-cc83e683cc40.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with a variety of cardio machines, including treadmills, ellipticals, and stationary bikes, to help you achieve your health and wellness goals.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, and stationary bikes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a7fc53f3-3364-461e-87b0-5014da5cfa15",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a6-0596-7189-a89a-dbc59e76e729.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, sofa, coffee table, and large artwork.",
        "public_id": "019e89a6-0596-7189-a89a-dbc59e76e729",
        "storage_key": "property/5712947535937536/019e89a6-0596-7189-a89a-dbc59e76e729.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a fireplace, plush sofa, decorative coffee table, and modern artwork, creating a welcoming atmosphere.",
      "link": "",
      "alt_text": "Living room with fireplace, sofa, coffee table, and large artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ae7031e3-fa4d-4969-9ed9-499342b3d074",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a5-f617-7603-aec5-d9a9353f570b.webp",
      "image_media": {
        "alt_text": "Wooden pier extending into a calm lake with apartment buildings in the background and a fountain in the water.",
        "public_id": "019e89a5-f617-7603-aec5-d9a9353f570b",
        "storage_key": "property/5712947535937536/019e89a5-f617-7603-aec5-d9a9353f570b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the serene waterfront views from the community pier, overlooking the lake and apartment homes. A perfect spot for relaxation.",
      "link": "",
      "alt_text": "Wooden pier extending into a calm lake with apartment buildings in the background and a fountain in the water.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_026c06d9-c3f9-4d8b-95fb-c25910ddcd01",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a5-f5d4-706b-8221-dedf283a911d.webp",
      "image_media": {
        "alt_text": "Apartment buildings with a fountain in a lake.",
        "public_id": "019e89a5-f5d4-706b-8221-dedf283a911d",
        "storage_key": "property/5712947535937536/019e89a5-f5d4-706b-8221-dedf283a911d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the serene lake views with a fountain, surrounded by beautiful apartment buildings and lush greenery.",
      "link": "",
      "alt_text": "Apartment buildings with a fountain in a lake.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_199cf4c6-b766-4552-b02b-9f66a399cf4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019e89a5-f545-766a-92ec-2a70afdc72cf.webp",
      "image_media": {
        "alt_text": "In-unit laundry room with washer and dryer",
        "public_id": "019e89a5-f545-766a-92ec-2a70afdc72cf",
        "storage_key": "property/5712947535937536/019e89a5-f545-766a-92ec-2a70afdc72cf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry facilities with a washer and dryer, making chores a breeze.",
      "link": "",
      "alt_text": "In-unit laundry room with washer and dryer",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_6698e048a2dc6168a015ded2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Metro Diner",
      "poi_type": "Restaurants",
      "poi_address": "1419 FL-436, Casselberry, FL 32707, USA",
      "poi_short_description": "Local diner chain serving classic American breakfast & lunch fare in a warm atmosphere.",
      "poi_long_description": "Local diner chain serving classic American breakfast & lunch fare in a warm atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-c5ca-7795-aaea-8f8ffdec09be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-c5ca-7795-aaea-8f8ffdec09be",
        "storage_key": "property/5712947535937536/019f1500-c5ca-7795-aaea-8f8ffdec09be.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://metrodiner.com/locations/florida/casselberry/?utm_source=gmb-listing-map&utm_medium=organic&utm_campaign=google-my-business",
      "poi_directions_map_url": "https://maps.google.com/?cid=7164791382280737732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metro-diner",
      "poi_latitude": "28.627172",
      "poi_longitude": "-81.31733",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 407-613-2418",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9cc-753d-a4fe-2197621a5abf",
        "storage_key": "property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx6G5tldx54gRxJOfLs1zbmM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "ec_6f40c744919679442d2363ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Cubans On the Run",
      "poi_type": "Restaurants",
      "poi_address": "2956 S US Hwy 17 92, Casselberry, FL 32707, USA",
      "poi_short_description": "Grab-&-go or eat in at this no-frills spot for Latin eats like empanadas, roast pork & plantains.",
      "poi_long_description": "Grab-&-go or eat in at this no-frills spot for Latin eats like empanadas, roast pork & plantains.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-c864-7637-84d2-9efe908c7b52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-c864-7637-84d2-9efe908c7b52",
        "storage_key": "property/5712947535937536/019f1500-c864-7637-84d2-9efe908c7b52.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cubansontherun.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2401598264024038061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cubans-on-the-run",
      "poi_latitude": "28.6800665",
      "poi_longitude": "-81.3360055",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 407-339-2272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9cc-753d-a4fe-2197621a5abf",
        "storage_key": "property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJb_42v_5t54gRrfpYnOUwVCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_de053c55901d0f38ae3f2ec3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Poblano's Cocina Mexicana",
      "poi_type": "Restaurants",
      "poi_address": "908 FL-436, Casselberry, FL 32707, USA",
      "poi_short_description": "Bright eatery offering classic Mexican fare such as burritos & carnitas, plus beer & tequila drinks.",
      "poi_long_description": "Bright eatery offering classic Mexican fare such as burritos & carnitas, plus beer & tequila drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-cc09-71c9-8efd-6aada11158e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-cc09-71c9-8efd-6aada11158e5",
        "storage_key": "property/5712947535937536/019f1500-cc09-71c9-8efd-6aada11158e5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.poblanoscocinamexicana.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10940835104780968796&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "poblanos-cocina-mexicana",
      "poi_latitude": "28.6499165",
      "poi_longitude": "-81.3251252",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 321-972-4663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9cc-753d-a4fe-2197621a5abf",
        "storage_key": "property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ46y1vuRx54gRXOOXjo-n1Zc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_e254ac5081820eb0bd9310ba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Original Anthony's NY Pizza - Casselberry FL",
      "poi_type": "Restaurants",
      "poi_address": "1455 FL-436 #105, Casselberry, FL 32707, USA",
      "poi_short_description": "Informal pizzeria serving New York-style pies, plus a standard roster of subs, pasta & calzones.",
      "poi_long_description": "Informal pizzeria serving New York-style pies, plus a standard roster of subs, pasta & calzones.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-ceb6-75fd-80ae-bc1534aa25f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-ceb6-75fd-80ae-bc1534aa25f9",
        "storage_key": "property/5712947535937536/019f1500-ceb6-75fd-80ae-bc1534aa25f9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://originalanthonys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12670344206405586220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "original-anthonys-ny-pizza---casselberry-fl",
      "poi_latitude": "28.6284877",
      "poi_longitude": "-81.3184005",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 407-657-5384",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9cc-753d-a4fe-2197621a5abf",
        "storage_key": "property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_UtssMpv54gRLM275Owa1q8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_62a35ee450e122cf3172bd4b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "An Vi Vietnamese Kitchen & Sandwich",
      "poi_type": "Restaurants",
      "poi_address": "1052 FL-436, Casselberry, FL 32707, USA",
      "poi_short_description": "Clean Vietnamese eatery cooking grilled pork skewers, chicken wings, fried tofu and pho.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-c6a3-74f6-bd7e-aeeadd2c7f4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-c6a3-74f6-bd7e-aeeadd2c7f4f",
        "storage_key": "property/5712947535937536/019f1500-c6a3-74f6-bd7e-aeeadd2c7f4f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.anvirestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16523299111462756856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "an-vi-vietnamese-kitchen--sandwich",
      "poi_latitude": "28.6449965",
      "poi_longitude": "-81.321092",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 321-972-1503",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9cc-753d-a4fe-2197621a5abf",
        "storage_key": "property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJubdTHNpv54gR-OFDaP-MTuU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "ec_82659cedf3819f62745586ff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Wah Yoan Chinese Food",
      "poi_type": "Restaurants",
      "poi_address": "3385 S US Hwy 17 92 #141, Casselberry, FL 32707, USA",
      "poi_short_description": "Compact, unadorned counter serve selling familiar Chinese-American staples, smoothies & milk tea.",
      "poi_long_description": "Compact, unadorned counter serve selling familiar Chinese-American staples, smoothies & milk tea.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-cb2a-77c0-a148-b7e7bde2ef13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-cb2a-77c0-a148-b7e7bde2ef13",
        "storage_key": "property/5712947535937536/019f1500-cb2a-77c0-a148-b7e7bde2ef13.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.wahyoanchinese.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6063649606987274223&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wah-yoan-chinese-food",
      "poi_latitude": "28.6792939",
      "poi_longitude": "-81.3343254",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 407-339-1788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9cc-753d-a4fe-2197621a5abf",
        "storage_key": "property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsYEKk_5t54gR79fp4jBpJlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_90bb80a9701dd82bd5e1508b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Four Guys Pho",
      "poi_type": "Restaurants",
      "poi_address": "Casselberry, FL 32730, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6922900622390606227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "four-guys-pho",
      "poi_latitude": "28.6545754",
      "poi_longitude": "-81.33318249999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9cc-753d-a4fe-2197621a5abf",
        "storage_key": "property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL7Sz3xhu54gRkzns3G8VE2A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_5532b6362aac74788982ad72",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "The Green Parrot",
      "poi_type": "Restaurants",
      "poi_address": "280 FL-436, Casselberry, FL 32707, USA",
      "poi_short_description": "Neighborhood joint with live music and karaoke, plus pool tables, darts and beer.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-c86e-73b8-a1cb-c4bf918fd3f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-c86e-73b8-a1cb-c4bf918fd3f2",
        "storage_key": "property/5712947535937536/019f1500-c86e-73b8-a1cb-c4bf918fd3f2.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://order.toasttab.com/online/the-green-parrot",
      "poi_directions_map_url": "https://maps.google.com/?cid=7589078251246125163&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-green-parrot",
      "poi_latitude": "28.6581713",
      "poi_longitude": "-81.3351879",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 407-332-1599",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-4570-744a-8a05-8d7ffcd14545.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-4570-744a-8a05-8d7ffcd14545",
        "storage_key": "property/5712947535937536/019f1501-4570-744a-8a05-8d7ffcd14545.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2ZyOKBxu54gRawAr-nXSUWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "ec_5d451909f8a4e047ab2e79f9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Einstein Bros. Bagels",
      "poi_type": "Restaurants",
      "poi_address": "150 FL-436, Casselberry, FL 32707, USA",
      "poi_short_description": "Coffee shop supplying signature breakfast sandwiches, a variety of bagels and a lunch menu.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-c79b-7237-a23c-8fc63f53db48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-c79b-7237-a23c-8fc63f53db48",
        "storage_key": "property/5712947535937536/019f1500-c79b-7237-a23c-8fc63f53db48.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://locations.einsteinbros.com/us/fl/casselberry/150-state-route-436?y_source=1_OTA0OTYyNS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6915923512215753694&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "einstein-bros-bagels",
      "poi_latitude": "28.6600059",
      "poi_longitude": "-81.3395287",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 321-207-7122",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9cc-753d-a4fe-2197621a5abf",
        "storage_key": "property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx2P8jh1u54gR3lNkz8pL-l8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bagel_shop"
    },
    {
      "id": "ec_5c57b5b9a5e46a3ec08fe1a6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Culver’s",
      "poi_type": "Restaurants",
      "poi_address": "3920 S US Hwy 17 92, Casselberry, FL 32707, USA",
      "poi_short_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_long_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-c99e-7779-b366-33a2da89de0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-c99e-7779-b366-33a2da89de0b",
        "storage_key": "property/5712947535937536/019f1500-c99e-7779-b366-33a2da89de0b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.culvers.com/restaurants/casselberry-fl-hwy-17-92/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=14351468153517048992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "culvers",
      "poi_latitude": "28.6755268",
      "poi_longitude": "-81.3374528",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 321-972-5134",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9cc-753d-a4fe-2197621a5abf",
        "storage_key": "property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJF0pM1P9t54gRoAS3jz-oKsc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_462e07430f16344e89a8f6e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Applebee's Grill + Bar",
      "poi_type": "Restaurants",
      "poi_address": "3315 S US Hwy 17 92, Casselberry, FL 32707, USA",
      "poi_short_description": "Full-service chain bar & grill providing hearty American eats in an informal setting.",
      "poi_long_description": "Full-service chain bar & grill providing hearty American eats in an informal setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-ccb6-7669-8b38-a455a843c25b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-ccb6-7669-8b38-a455a843c25b",
        "storage_key": "property/5712947535937536/019f1500-ccb6-7669-8b38-a455a843c25b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://restaurants.applebees.com/en-us/fl/casselberry/3315-us-highway-17-92-77048?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=77048&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=5084765080604798751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "applebees-grill--bar",
      "poi_latitude": "28.6794961",
      "poi_longitude": "-81.3349994",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-960-7928",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9cc-753d-a4fe-2197621a5abf",
        "storage_key": "property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDUibov5t54gRH2_Ci-a2kEY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_e0cb85f416e1bef4ef835575",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "1387 FL-436, Casselberry, FL 32707, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-d016-77fa-b5b7-732de6ad7da5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-d016-77fa-b5b7-732de6ad7da5",
        "storage_key": "property/5712947535937536/019f1500-d016-77fa-b5b7-732de6ad7da5.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://locations.chipotle.com/fl/casselberry/1389-sr-436",
      "poi_directions_map_url": "https://maps.google.com/?cid=18030885584916485061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "28.6296436",
      "poi_longitude": "-81.31852789999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 321-280-9620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9cc-753d-a4fe-2197621a5abf",
        "storage_key": "property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT5c1V4Rv54gRxZOoYuiSOvo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_4408243ef182c14146ad04e6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "4 Rivers Smokehouse",
      "poi_type": "Restaurants",
      "poi_address": "1869 W State Rd 434, Longwood, FL 32750, USA",
      "poi_short_description": "Counter-serve chain eatery featuring Texas-style BBQ, homestyle sides & sweet treats.",
      "poi_long_description": "Counter-serve chain eatery featuring Texas-style BBQ, homestyle sides & sweet treats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-ce65-71fc-a3cb-4f8a390c458c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-ce65-71fc-a3cb-4f8a390c458c",
        "storage_key": "property/5712947535937536/019f1500-ce65-71fc-a3cb-4f8a390c458c.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.4rsmokehouse.com/locations/longwood/?utm_source=gmb&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=5661669242802726585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "4-rivers-smokehouse",
      "poi_latitude": "28.6929235",
      "poi_longitude": "-81.387253",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 321-599-4242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9cc-753d-a4fe-2197621a5abf",
        "storage_key": "property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_yhr5sxz54gRueYC9S1Kkk4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_1017bd8f4967cfe3e6b6538a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Otto’s High Dive",
      "poi_type": "Restaurants",
      "poi_address": "2304 E Robinson St, Orlando, FL 32803, USA",
      "poi_short_description": "Trendy restaurant serving Cuban dishes and rum drinks in a cozy environment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-d381-7399-82c7-72c977ccaec4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-d381-7399-82c7-72c977ccaec4",
        "storage_key": "property/5712947535937536/019f1500-d381-7399-82c7-72c977ccaec4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://ottoshd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=226959237993064898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ottos-high-dive",
      "poi_latitude": "28.5458202",
      "poi_longitude": "-81.3526658",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 321-231-7902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9cc-753d-a4fe-2197621a5abf",
        "storage_key": "property/5712947535937536/019f14fe-b9cc-753d-a4fe-2197621a5abf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOwkr93R754gRwukRdzlSJgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_9edfdcf0263bf59f278c2df4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Publix Super Market at Casselberry Commons",
      "poi_type": "Shopping & Retail",
      "poi_address": "1455 FL-436 #221, Casselberry, FL 32707, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-d09e-7154-bed3-7d60c8851103.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-d09e-7154-bed3-7d60c8851103",
        "storage_key": "property/5712947535937536/019f1500-d09e-7154-bed3-7d60c8851103.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1285&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=9940253778324005024&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-casselberry-commons",
      "poi_latitude": "28.6273341",
      "poi_longitude": "-81.3193829",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 407-673-0162",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9c8-741a-9d0b-68c0a47520a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9c8-741a-9d0b-68c0a47520a5",
        "storage_key": "property/5712947535937536/019f14fe-b9c8-741a-9d0b-68c0a47520a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_UtssMpv54gRoKA8SiXg8ok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_8c9ecf69d27f30b1ad835d4e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1239 FL-436 Ste 101, Casselberry, FL 32707, USA",
      "poi_short_description": "Retail chain stocking clothing, toys, electronics and home goods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-d2f7-74fd-afa4-4083ec54f05e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-d2f7-74fd-afa4-4083ec54f05e",
        "storage_key": "property/5712947535937536/019f1500-d2f7-74fd-afa4-4083ec54f05e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walmart.com/store/943-casselberry-fl/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=8442093221604895544&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "28.6347516",
      "poi_longitude": "-81.3232663",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 407-679-0377",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-ba04-76c9-a342-08fcabc1801a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-ba04-76c9-a342-08fcabc1801a",
        "storage_key": "property/5712947535937536/019f14fe-ba04-76c9-a342-08fcabc1801a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJb82-35pj54gROCt-kg5XKHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_c26572e238c6b037a26e1e87",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Sun Lake Plaza Inc",
      "poi_type": "Shopping & Retail",
      "poi_address": "1750 Sunshadow Dr #146, Casselberry, FL 32707, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-d4eb-759c-9a63-3bf62850dc03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-d4eb-759c-9a63-3bf62850dc03",
        "storage_key": "property/5712947535937536/019f1500-d4eb-759c-9a63-3bf62850dc03.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17114226900513815954&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sun-lake-plaza-inc",
      "poi_latitude": "28.6964295",
      "poi_longitude": "-81.32171749999999",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 407-699-8665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9fc-7160-b11a-32944c092560",
        "storage_key": "property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2YYWOutt54gRkn2P4rDyge0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_401d554fe98913b4c96030f6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Family Produce Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "670 FL-436, Casselberry, FL 32707, USA",
      "poi_short_description": "Family-run store offering produce, Middle Eastern ingredients and cheese.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-d568-7408-9c0b-3dcae636ab73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-d568-7408-9c0b-3dcae636ab73",
        "storage_key": "property/5712947535937536/019f1500-d568-7408-9c0b-3dcae636ab73.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9810164901830375137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-produce-market",
      "poi_latitude": "28.6530233",
      "poi_longitude": "-81.32941389999999",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 407-679-3322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9c8-741a-9d0b-68c0a47520a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9c8-741a-9d0b-68c0a47520a5",
        "storage_key": "property/5712947535937536/019f14fe-b9c8-741a-9d0b-68c0a47520a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6RINLBxu54gR4baacQC1JIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_c677ae909ec3849ea400aeeb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "T.J. Maxx",
      "poi_type": "Shopping & Retail",
      "poi_address": "1455 Semoran Blvd, Casselberry, FL 32707, USA",
      "poi_short_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_long_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-d483-710f-b707-e333504ab473.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-d483-710f-b707-e333504ab473",
        "storage_key": "property/5712947535937536/019f1500-d483-710f-b707-e333504ab473.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://tjmaxx.tjx.com/store/index.jsp",
      "poi_directions_map_url": "https://maps.google.com/?cid=3260750482727138341&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tj-maxx",
      "poi_latitude": "28.627876",
      "poi_longitude": "-81.319429",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 407-671-0851",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-ba04-76c9-a342-08fcabc1801a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-ba04-76c9-a342-08fcabc1801a",
        "storage_key": "property/5712947535937536/019f14fe-ba04-76c9-a342-08fcabc1801a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4foVSzVu54gRJXQisEmDQC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_b24238c3b61f335b03e8bf59",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Burlington",
      "poi_type": "Shopping & Retail",
      "poi_address": "1455 Semoran Blvd Ste 251, Casselberry, FL 32707, USA",
      "poi_short_description": "Spacious, organized, bargain-priced store selling clothes, jewelry, handbags, shoes and home goods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-d817-778c-991c-397a231bbe18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-d817-778c-991c-397a231bbe18",
        "storage_key": "property/5712947535937536/019f1500-d817-778c-991c-397a231bbe18.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.burlington.com/stores/fl/casselberry/1351?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10186618307772523220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burlington",
      "poi_latitude": "28.6261949",
      "poi_longitude": "-81.3192401",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 689-209-1967",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-ba04-76c9-a342-08fcabc1801a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-ba04-76c9-a342-08fcabc1801a",
        "storage_key": "property/5712947535937536/019f14fe-ba04-76c9-a342-08fcabc1801a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_3Qgo1xv54gR1KJFQWEjXo0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "ec_81fd643e7843ecc732ddbed4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "955 S Winter Park Dr, Casselberry, FL 32707, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-d824-75ba-8cdf-f3eec9019162.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-d824-75ba-8cdf-f3eec9019162",
        "storage_key": "property/5712947535937536/019f1500-d824-75ba-8cdf-f3eec9019162.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-955+s+winter+park+dr-casselberry-fl-32707/id=5399",
      "poi_directions_map_url": "https://maps.google.com/?cid=5689284636515986203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "28.6480997",
      "poi_longitude": "-81.3230506",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 407-767-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9fc-7160-b11a-32944c092560",
        "storage_key": "property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEb-Ghj5u54gRG2uf2Ttm9E4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_fe44cdb0ca6484dc085f5ab9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "1000 Seminola Blvd, Casselberry, FL 32707, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-da02-734f-aac5-65972b3018d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-da02-734f-aac5-65972b3018d9",
        "storage_key": "property/5712947535937536/019f1500-da02-734f-aac5-65972b3018d9.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.7-eleven.com/locations/fl/casselberry/1000-seminola-blvd-34873?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=7965557779941376901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "28.6743114",
      "poi_longitude": "-81.3172701",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 407-695-1795",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-4586-70ff-9793-a69f5673d336.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-4586-70ff-9793-a69f5673d336",
        "storage_key": "property/5712947535937536/019f1501-4586-70ff-9793-a69f5673d336.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJBUBw5N9t54gRhUNB95hYi24",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_56920723f6b2f885cc9831e3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "4410 S US Hwy 17 92, Casselberry, FL 32707, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-d892-720a-9db5-3352c60af81b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-d892-720a-9db5-3352c60af81b",
        "storage_key": "property/5712947535937536/019f1500-d892-720a-9db5-3352c60af81b.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/casselberry/898",
      "poi_directions_map_url": "https://maps.google.com/?cid=3163388705540008938&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "28.6715157",
      "poi_longitude": "-81.3409728",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-830-7979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-ba04-76c9-a342-08fcabc1801a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-ba04-76c9-a342-08fcabc1801a",
        "storage_key": "property/5712947535937536/019f14fe-ba04-76c9-a342-08fcabc1801a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJO3CidfBt54gR6usxcESd5is",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_4507d9d98ca4b888833011c8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "3455 S US Hwy 17 92, Casselberry, FL 32707, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-dac2-741d-8576-3bd53ddc6d10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-dac2-741d-8576-3bd53ddc6d10",
        "storage_key": "property/5712947535937536/019f1500-dac2-741d-8576-3bd53ddc6d10.webp",
        "width": 879,
        "height": 680
      },
      "poi_business_url": "https://www.homedepot.com/l/Casselberry/FL/Casselberry/32707/262?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8078457563401388770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "28.6766525",
      "poi_longitude": "-81.33407129999999",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 407-332-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-ba04-76c9-a342-08fcabc1801a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-ba04-76c9-a342-08fcabc1801a",
        "storage_key": "property/5712947535937536/019f14fe-ba04-76c9-a342-08fcabc1801a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJH6V9dfBt54gR4oKbN1pyHHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_12425ad8e5484ac86a487a0f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Casselberry Elementary School",
      "poi_type": "Education",
      "poi_address": "1075 Crystal Bowl Cir, Casselberry, FL 32707, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-db28-72e9-873d-4a8fd6016ed7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-db28-72e9-873d-4a8fd6016ed7",
        "storage_key": "property/5712947535937536/019f1500-db28-72e9-873d-4a8fd6016ed7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://casselberry.scps.k12.fl.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18341214921381969225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "casselberry-elementary-school",
      "poi_latitude": "28.6608616",
      "poi_longitude": "-81.3169728",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 407-746-2550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9ca-7370-be2c-2b128af15cd8",
        "storage_key": "property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ49T-2xJu54gRSf0QissVif4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_363a3b563badc23671099f2a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Red Bug Elementary School",
      "poi_type": "Education",
      "poi_address": "4000 Red Bug Lake Rd, Casselberry, FL 32707, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-dc5c-759e-8cc0-32d6a8f38a8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-dc5c-759e-8cc0-32d6a8f38a8b",
        "storage_key": "property/5712947535937536/019f1500-dc5c-759e-8cc0-32d6a8f38a8b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.redbug.scps.k12.fl.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=371528690898869578&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-bug-elementary-school",
      "poi_latitude": "28.64895499999999",
      "poi_longitude": "-81.28237",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 407-746-8350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9ca-7370-be2c-2b128af15cd8",
        "storage_key": "property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUc7zuexu54gRSp3kPGDvJwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_617277525361d16ec1a7fbb2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Sterling Park Elementary School",
      "poi_type": "Education",
      "poi_address": "905 Eagle Cir S, Casselberry, FL 32707, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-dcbe-71cd-9d08-c068ca1a3517.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-dcbe-71cd-9d08-c068ca1a3517",
        "storage_key": "property/5712947535937536/019f1500-dcbe-71cd-9d08-c068ca1a3517.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sterlingpark.scps.k12.fl.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7406930197356087085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sterling-park-elementary-school",
      "poi_latitude": "28.6523202",
      "poi_longitude": "-81.3047826",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 407-746-8250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9ca-7370-be2c-2b128af15cd8",
        "storage_key": "property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHaoarWdu54gRLQeGWcWzymY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_23a5277e166a2e61cc707f55",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "South Seminole Academy",
      "poi_type": "Education",
      "poi_address": "101 S Winter Park Dr, Casselberry, FL 32707, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-dfe3-7437-8def-0ca74d6e0765.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-dfe3-7437-8def-0ca74d6e0765",
        "storage_key": "property/5712947535937536/019f1500-dfe3-7437-8def-0ca74d6e0765.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ssms.scps.k12.fl.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4800722166945701527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-seminole-academy",
      "poi_latitude": "28.6602771",
      "poi_longitude": "-81.3192086",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-746-1350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9ca-7370-be2c-2b128af15cd8",
        "storage_key": "property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9WVXLW1u54gRl14kImCXn0I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_a4be8a71a2abf246b5cfe83f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Lake Howell High School",
      "poi_type": "Education",
      "poi_address": "4200 Dike Rd, Winter Park, FL 32792, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-debd-73bc-aada-4378a62dada0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-debd-73bc-aada-4378a62dada0",
        "storage_key": "property/5712947535937536/019f1500-debd-73bc-aada-4378a62dada0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.lakehowell.scps.k12.fl.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8501116865614413407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-howell-high-school",
      "poi_latitude": "28.6377084",
      "poi_longitude": "-81.2737006",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 407-746-9050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9ca-7370-be2c-2b128af15cd8",
        "storage_key": "property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK9bRq8Ju54gRX34Hmb8I-nU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_32800379e6094be9d09e38ff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Socrates Preparatory School",
      "poi_type": "Education",
      "poi_address": "3955 Red Bug Lake Rd, Casselberry, FL 32707, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-dea7-772f-b16f-1077f0491ec3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-dea7-772f-b16f-1077f0491ec3",
        "storage_key": "property/5712947535937536/019f1500-dea7-772f-b16f-1077f0491ec3.webp",
        "width": 450,
        "height": 450
      },
      "poi_business_url": "http://www.socratesprep.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=137561133378161753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "socrates-preparatory-school",
      "poi_latitude": "28.6460951",
      "poi_longitude": "-81.2818047",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 321-422-0825",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9ca-7370-be2c-2b128af15cd8",
        "storage_key": "property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu6dV--xu54gRWcznOR-36AE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_299655e147e86be3f4975a12",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Rivers Edge Academy - Red Bug Lake",
      "poi_type": "Education",
      "poi_address": "900 Dodd Rd, Casselberry, FL 32707, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-df78-753d-9bf4-3c2d887a8e39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-df78-753d-9bf4-3c2d887a8e39",
        "storage_key": "property/5712947535937536/019f1500-df78-753d-9bf4-3c2d887a8e39.webp",
        "width": 649,
        "height": 393
      },
      "poi_business_url": "https://www.riversedgeacademy.com/redbuglake",
      "poi_directions_map_url": "https://maps.google.com/?cid=12595132989554952209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rivers-edge-academy---red-bug-lake",
      "poi_latitude": "28.6498728",
      "poi_longitude": "-81.2799696",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-565-7393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9ca-7370-be2c-2b128af15cd8",
        "storage_key": "property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzQYXZ5Nu54gREQg63bjmyq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_9a1e5084811f60fd52b37902",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Magnolia Kids Academy - Accredited Childcare Facility",
      "poi_type": "Education",
      "poi_address": "980 Eagle Cir, Casselberry, FL 32707, USA",
      "poi_short_description": "Learning center offering child care and preschool services in an environment that's said to be loving and supportive.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-df86-736a-8861-191cb8de590e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-df86-736a-8861-191cb8de590e",
        "storage_key": "property/5712947535937536/019f1500-df86-736a-8861-191cb8de590e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://magnoliakidsacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17401568021428036776&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "magnolia-kids-academy---accredited-childcare-facility",
      "poi_latitude": "28.653173",
      "poi_longitude": "-81.30891799999999",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 407-696-3023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9ca-7370-be2c-2b128af15cd8",
        "storage_key": "property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwQVWGhu54gRqOQDBOvJfvE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_2d3ce69b03b741c58be58d5e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Kid City USA - Winter Springs",
      "poi_type": "Education",
      "poi_address": "1015 Willa Springs Dr, Winter Springs, FL 32708, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-e18a-74cb-a325-d1e5ce45bcd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-e18a-74cb-a325-d1e5ce45bcd4",
        "storage_key": "property/5712947535937536/019f1500-e18a-74cb-a325-d1e5ce45bcd4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://kidcityusa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1226320733691732382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kid-city-usa---winter-springs",
      "poi_latitude": "28.6460163",
      "poi_longitude": "-81.2722575",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-695-7737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9ca-7370-be2c-2b128af15cd8",
        "storage_key": "property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy5PzRsBu54gRnmFkwDXEBBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_7585ae0a56d756031ec1abe5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Full Sail University",
      "poi_type": "Education",
      "poi_address": "3300 University Blvd, Winter Park, FL 32792, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-80f0-70dc-a9a7-0fe05dc7193a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-80f0-70dc-a9a7-0fe05dc7193a",
        "storage_key": "property/5712947535937536/019f14fe-80f0-70dc-a9a7-0fe05dc7193a.webp",
        "width": 1280,
        "height": 610
      },
      "poi_business_url": "http://www.fullsail.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=855905939834810820&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "full-sail-university",
      "poi_latitude": "28.5963064",
      "poi_longitude": "-81.30106239999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-226-7625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9ca-7370-be2c-2b128af15cd8",
        "storage_key": "property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs46KUppv54gRxDEA4erJ4As",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_4474da67123758cc0c07d609",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Scenic Boat Tour",
      "poi_type": "Entertainment",
      "poi_address": "312 E Morse Blvd, Winter Park, FL 32789, USA",
      "poi_short_description": "Scenic hour-long boat tour of lakes and canals with guides discussing the history of the area and its notable homes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-e2b4-758f-ada8-ddb7d607c8a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-e2b4-758f-ada8-ddb7d607c8a2",
        "storage_key": "property/5712947535937536/019f1500-e2b4-758f-ada8-ddb7d607c8a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.scenicboattours.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14946514596029344282&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scenic-boat-tour",
      "poi_latitude": "28.597905",
      "poi_longitude": "-81.34683559999999",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 407-644-4056",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9fc-7160-b11a-32944c092560",
        "storage_key": "property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4XkjoBtw54gRGiqFxtWvbM8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tour_agency"
    },
    {
      "id": "ec_491463cc475c0de18c43f9c6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "The Charles Hosmer Morse Museum of American Art",
      "poi_type": "Entertainment",
      "poi_address": "445 N Park Ave, Winter Park, FL 32789, USA",
      "poi_short_description": "Historic, family-friendly museum featuring extensive Tiffany collection & special exhibits.",
      "poi_long_description": "Historic, family-friendly museum featuring extensive Tiffany collection & special exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-8bda-70e8-90f8-df62ee8d10c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-8bda-70e8-90f8-df62ee8d10c4",
        "storage_key": "property/5712947535937536/019f14fe-8bda-70e8-90f8-df62ee8d10c4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.morsemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5160767911464931185&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-charles-hosmer-morse-museum-of-american-art",
      "poi_latitude": "28.6008557",
      "poi_longitude": "-81.3513439",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 407-645-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-ba08-7170-a9f3-0d79453dd372.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-ba08-7170-a9f3-0d79453dd372",
        "storage_key": "property/5712947535937536/019f14fe-ba08-7170-a9f3-0d79453dd372.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJx4O9VBdw54gRcQ8akxK7nkc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_4bc56ef7843644166fc4f568",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Enzian Theater",
      "poi_type": "Entertainment",
      "poi_address": "1300 S Orlando Ave, Maitland, FL 32751, USA",
      "poi_short_description": "Nonprofit indie theater for cult & matinee classics, plus special events & a bar amid towering oaks.",
      "poi_long_description": "Nonprofit indie theater for cult & matinee classics, plus special events & a bar amid towering oaks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-ea0d-733b-9b87-eb4f62fec488.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-ea0d-733b-9b87-eb4f62fec488",
        "storage_key": "property/5712947535937536/019f1500-ea0d-733b-9b87-eb4f62fec488.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://enzian.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6818751612280462564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enzian-theater",
      "poi_latitude": "28.6164719",
      "poi_longitude": "-81.3644008",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 407-629-0054",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-4580-735d-9995-42397ecb71d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-4580-735d-9995-42397ecb71d4",
        "storage_key": "property/5712947535937536/019f1501-4580-735d-9995-42397ecb71d4.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-WLCqkdw54gR5FyZzXYSoV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_ec5fe76b8a235d2254e9e89a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Mennello Museum of American Art",
      "poi_type": "Entertainment",
      "poi_address": "900 E Princeton St, Orlando, FL 32803, USA",
      "poi_short_description": "Small museum dedicated to American art, with a lakeside sculpture garden on its manicured grounds.",
      "poi_long_description": "Small museum dedicated to American art, with a lakeside sculpture garden on its manicured grounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-eb35-71b6-9c9d-84513ee36aac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-eb35-71b6-9c9d-84513ee36aac",
        "storage_key": "property/5712947535937536/019f1500-eb35-71b6-9c9d-84513ee36aac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mennellomuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7535974175057793326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mennello-museum-of-american-art",
      "poi_latitude": "28.570012",
      "poi_longitude": "-81.3673",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 407-246-4278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-ba08-7170-a9f3-0d79453dd372.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-ba08-7170-a9f3-0d79453dd372",
        "storage_key": "property/5712947535937536/019f14fe-ba08-7170-a9f3-0d79453dd372.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJlcJ_05B654gRLlHWvJUolWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_2cbab9e709f5bfa4422072e3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "The Plaza Live",
      "poi_type": "Entertainment",
      "poi_address": "425 N Bumby Ave, Orlando, FL 32803, USA",
      "poi_short_description": "Household-name bands join local musicians & comedians at this understated former movie theater.",
      "poi_long_description": "Household-name bands join local musicians & comedians at this understated former movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-eb45-714f-9f37-691ce0675926.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-eb45-714f-9f37-691ce0675926",
        "storage_key": "property/5712947535937536/019f1500-eb45-714f-9f37-691ce0675926.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.plazaliveorlando.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2850904608295288036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-plaza-live",
      "poi_latitude": "28.5486774",
      "poi_longitude": "-81.3513424",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 407-228-1220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9fc-7160-b11a-32944c092560",
        "storage_key": "property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHWBuq9p654gR5Pz28aJykCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "concert_hall"
    },
    {
      "id": "ec_aa5ec33f4a59e4a22783818e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Cranes Roost Park",
      "poi_type": "Entertainment",
      "poi_address": "274 Cranes Roost Blvd, Altamonte Springs, FL 32701, USA",
      "poi_short_description": "Lakeside area featuring a walking path, plaza with fountain show & amphitheater for outdoor events.",
      "poi_long_description": "Lakeside area featuring a walking path, plaza with fountain show & amphitheater for outdoor events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-a46c-75c8-a698-4a8a2b9574b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-a46c-75c8-a698-4a8a2b9574b9",
        "storage_key": "property/5712947535937536/019f14fe-a46c-75c8-a698-4a8a2b9574b9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.altamonte.org/367/Cranes-Roost-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6758105619229818020&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cranes-roost-park",
      "poi_latitude": "28.665192",
      "poi_longitude": "-81.384577",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 407-571-8180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9e3-71f2-b0a4-d245e89fec67",
        "storage_key": "property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0XiHxYJx54gRpLzDNEGdyV0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_48408a521cb34734bde3e430",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Central Florida Zoo & Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "3755 W Seminole Blvd, Sanford, FL 32771, USA",
      "poi_short_description": "Opened in 1923, this zoo stars endangered big cats & reptiles, plus a zip line & rope bridges.",
      "poi_long_description": "Opened in 1923, this zoo stars endangered big cats & reptiles, plus a zip line & rope bridges.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-f598-754a-9b49-de2143414464.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-f598-754a-9b49-de2143414464",
        "storage_key": "property/5712947535937536/019f1500-f598-754a-9b49-de2143414464.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.centralfloridazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2023281930562440895&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-florida-zoo--botanical-gardens",
      "poi_latitude": "28.8255223",
      "poi_longitude": "-81.3148671",
      "poi_miles_from_property": "17.0 mi",
      "poi_walking_minutes": "6 hours 16 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 407-323-4450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9fc-7160-b11a-32944c092560",
        "storage_key": "property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9TyG2GkS54gRvw6kLzIkFBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "ec_d968a8d25c9a7641e1e387e2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "The Maitland Art Center",
      "poi_type": "Entertainment",
      "poi_address": "W Packwood Ave, Maitland, FL 32751, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-f6e0-7755-b74b-c46e2563314c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-f6e0-7755-b74b-c46e2563314c",
        "storage_key": "property/5712947535937536/019f1500-f6e0-7755-b74b-c46e2563314c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://artandhistory.org/maitland-art-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3899439163579762059&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-maitland-art-center",
      "poi_latitude": "28.6258252",
      "poi_longitude": "-81.3671913",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9fc-7160-b11a-32944c092560",
        "storage_key": "property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL-fC-Utw54gRiwVrWEKXHTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_4667531d37076343176a7cf1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Orlando Science Center",
      "poi_type": "Entertainment",
      "poi_address": "777 E Princeton St, Orlando, FL 32803, USA",
      "poi_short_description": "Venerable science center with hands-on exhibits & planetarium shows, plus giant-screen & 3-D films.",
      "poi_long_description": "Venerable science center with hands-on exhibits & planetarium shows, plus giant-screen & 3-D films.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-8789-7779-a357-21f0b7613046.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-8789-7779-a357-21f0b7613046",
        "storage_key": "property/5712947535937536/019f14fe-8789-7779-a357-21f0b7613046.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.osc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13044009956314809596&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-science-center",
      "poi_latitude": "28.5722626",
      "poi_longitude": "-81.3682645",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 407-514-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-ba08-7170-a9f3-0d79453dd372.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-ba08-7170-a9f3-0d79453dd372",
        "storage_key": "property/5712947535937536/019f14fe-ba08-7170-a9f3-0d79453dd372.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2bql5B654gR_ITN9PGhBbU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_9224dc56baa35e5669b4d084",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "The Winter Park Playhouse",
      "poi_type": "Entertainment",
      "poi_address": "711 N Orange Ave, Winter Park, FL 32789, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-f5e0-72dd-a9be-c15a3a047894.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-f5e0-72dd-a9be-c15a3a047894",
        "storage_key": "property/5712947535937536/019f1500-f5e0-72dd-a9be-c15a3a047894.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.winterparkplayhouse.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11444804649248928517&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-winter-park-playhouse",
      "poi_latitude": "28.5920151",
      "poi_longitude": "-81.3581896",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 407-645-0145",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9fc-7160-b11a-32944c092560",
        "storage_key": "property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT4R3C9hx54gRBbM4-jAd1J4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_97bcbe1a4d65e9ce3d4ca135",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "AdventHealth Altamonte Springs",
      "poi_type": "Health and Wellness",
      "poi_address": "601 E Altamonte Dr, Altamonte Springs, FL 32701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-9666-7702-bbf1-0f21c5c00b05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-9666-7702-bbf1-0f21c5c00b05",
        "storage_key": "property/5712947535937536/019f14fe-9666-7702-bbf1-0f21c5c00b05.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.adventhealth.com/hospital/adventhealth-altamonte-springs",
      "poi_directions_map_url": "https://maps.google.com/?cid=17515573958040800705&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-altamonte-springs",
      "poi_latitude": "28.6656798",
      "poi_longitude": "-81.3694347",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 407-303-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9ca-7370-be2c-2418f709a9ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9ca-7370-be2c-2418f709a9ef",
        "storage_key": "property/5712947535937536/019f14fe-b9ca-7370-be2c-2418f709a9ef.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJCRMzrJFx54gRwc0anrbRE_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_92e698b49d02e8f387a8eb0c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "AFC Urgent Care Casselberry",
      "poi_type": "Health and Wellness",
      "poi_address": "3385 S US Hwy 17 92 #285, Casselberry, FL 32707, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-f69c-70ac-9648-5019bef5afa0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-f69c-70ac-9648-5019bef5afa0",
        "storage_key": "property/5712947535937536/019f1500-f69c-70ac-9648-5019bef5afa0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.afcurgentcare.com/casselberry/?utm_source=gmb&utm_medium=organic&utm_campaign=afc-casselberry-gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=18199783531094803132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "afc-urgent-care-casselberry",
      "poi_latitude": "28.67787419999999",
      "poi_longitude": "-81.3350854",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-883-0908",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9fc-7160-b11a-32944c092560",
        "storage_key": "property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF-eIHv5t54gRvALp57Gekvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_d2c379eeafde146d39d3355e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Cambridge Oaks Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3950 S US Hwy 17 92 suite 1048, Casselberry, FL 32707, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-0a6e-72b9-9f1b-0f67871d3d95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-0a6e-72b9-9f1b-0f67871d3d95",
        "storage_key": "property/5712947535937536/019f1501-0a6e-72b9-9f1b-0f67871d3d95.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cambridgeoaksrx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18101509758284272846&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cambridge-oaks-pharmacy",
      "poi_latitude": "28.6748343",
      "poi_longitude": "-81.33780689999999",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-960-4712",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-458e-75a8-874e-851aa07582c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-458e-75a8-874e-851aa07582c7",
        "storage_key": "property/5712947535937536/019f1501-458e-75a8-874e-851aa07582c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ67p6cABu54gRzhTNIDh7Nfs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_4561346f0aa3ab8b38300e70",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4410 S US Hwy 17 92, Casselberry, FL 32707, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-fc02-77f2-b170-ccdfb57f8799.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-fc02-77f2-b170-ccdfb57f8799",
        "storage_key": "property/5712947535937536/019f1500-fc02-77f2-b170-ccdfb57f8799.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/casselberry-fl-pharmacies/4410-s-highway-17-92-casselberry-fl-32707/storeid=16330?WT.mc_id=LS_GOOGLE_RX_16330",
      "poi_directions_map_url": "https://maps.google.com/?cid=15004924232033299123&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "28.6715157",
      "poi_longitude": "-81.3409728",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-830-6363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-458e-75a8-874e-851aa07582c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-458e-75a8-874e-851aa07582c7",
        "storage_key": "property/5712947535937536/019f1501-458e-75a8-874e-851aa07582c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO3CidfBt54gRs-r-6xYzPNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_d52e341467c87c2c15d25990",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Publix Pharmacy at Casselberry Commons",
      "poi_type": "Health and Wellness",
      "poi_address": "1455 FL-436 #221, Casselberry, FL 32707, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1500-fc5c-77fe-b32c-1bcf4c8209bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-fc5c-77fe-b32c-1bcf4c8209bf",
        "storage_key": "property/5712947535937536/019f1500-fc5c-77fe-b32c-1bcf4c8209bf.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.publix.com/pharmacy?utm_medium=maps&utm_source=google&utm_content=psmpharm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=9003347048220233786&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-pharmacy-at-casselberry-commons",
      "poi_latitude": "28.6272877",
      "poi_longitude": "-81.3193465",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 407-673-0788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-458e-75a8-874e-851aa07582c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-458e-75a8-874e-851aa07582c7",
        "storage_key": "property/5712947535937536/019f1501-458e-75a8-874e-851aa07582c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy0sm7GJl54gROpC6RnBQ8nw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_d42c9451f991eb228541966a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Crunch Fitness - Casselberry",
      "poi_type": "Health and Wellness",
      "poi_address": "1040 FL-436, Casselberry, FL 32707, USA",
      "poi_short_description": "Gym featuring cardio equipment and weights alongside group fitness classes and personal trainers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-8c91-7219-9db3-23c30c331cc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-8c91-7219-9db3-23c30c331cc2",
        "storage_key": "property/5712947535937536/019f14fe-8c91-7219-9db3-23c30c331cc2.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.crunch.com/locations/casselberry",
      "poi_directions_map_url": "https://maps.google.com/?cid=6979029945167782601&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crunch-fitness---casselberry",
      "poi_latitude": "28.6453511",
      "poi_longitude": "-81.3210957",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 407-707-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9fc-7160-b11a-32944c092560",
        "storage_key": "property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLUO7w4Bv54gRySKKNsJ-2mA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_bf8df9b00c3cd80d0e4b8b19",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "HOTWORX - Winter Park, FL - Howell Branch, Rd.",
      "poi_type": "Health and Wellness",
      "poi_address": "2525 Howell Branch Rd #1045, Casselberry, FL 32707, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://hotworx.net/studio/winterpark-howellbranchrd?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=9336219720733921838&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---winter-park-fl---howell-branch-rd",
      "poi_latitude": "28.6259837",
      "poi_longitude": "-81.3168036",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 407-550-6860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9ca-7370-be2c-2b128af15cd8",
        "storage_key": "property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJad90eRFv54gRLpJX317qkIE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_b44d3474949bd3b6d688e3aa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "IM=X Pilates and Fitness Winter Park",
      "poi_type": "Health and Wellness",
      "poi_address": "1271 Semoran Blvd #155, Casselberry, FL 32707, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-01e5-742e-8b9e-3215bdf4a0b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-01e5-742e-8b9e-3215bdf4a0b1",
        "storage_key": "property/5712947535937536/019f1501-01e5-742e-8b9e-3215bdf4a0b1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.imxpilates.com/florida/winter-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14971289441499191224&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "imx-pilates-and-fitness-winter-park",
      "poi_latitude": "28.6330983",
      "poi_longitude": "-81.321461",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 689-331-3351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9ca-7370-be2c-2b128af15cd8",
        "storage_key": "property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCyvQNE5v54gRuJcd_my0xM8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_7f6253693dbadd008e2b654f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "True Health - Casselberry",
      "poi_type": "Health and Wellness",
      "poi_address": "1120 FL-436 #1600, Casselberry, FL 32707, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-0390-71f2-92a5-d1e82298fb92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-0390-71f2-92a5-d1e82298fb92",
        "storage_key": "property/5712947535937536/019f1501-0390-71f2-92a5-d1e82298fb92.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.mytruehealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2147749281562977519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "true-health---casselberry",
      "poi_latitude": "28.6383641",
      "poi_longitude": "-81.3203522",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 407-322-8645",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9fc-7160-b11a-32944c092560",
        "storage_key": "property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn8iCnDdu54gR72QpopdWzh0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_442d44e7f98026da214f77e3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Ancient Art Massage & Bodywork",
      "poi_type": "Health and Wellness",
      "poi_address": "515 FL-436 #1018, Casselberry, FL 32730, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.bodyworkermassage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14588557919363881375&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ancient-art-massage--bodywork",
      "poi_latitude": "28.6543977",
      "poi_longitude": "-81.33271599999999",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 321-438-3726",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9fc-7160-b11a-32944c092560",
        "storage_key": "property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0VbYPUtw54gRn1nlWCL4dMo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "massage"
    },
    {
      "id": "ec_2480559e94bdf6d1bdcf01d9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Secret Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "200 N Triplet Lake Dr, Casselberry, FL 32707, USA",
      "poi_short_description": "Park with 3 lakes, playground, boardwalk, field, fishing pier, sport courts & recreation center.",
      "poi_long_description": "Park with 3 lakes, playground, boardwalk, field, fishing pier, sport courts & recreation center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-0cca-7451-a137-d617d2d7e0a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-0cca-7451-a137-d617d2d7e0a1",
        "storage_key": "property/5712947535937536/019f1501-0cca-7451-a137-d617d2d7e0a1.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://www.casselberry.org/index.aspx?NID=303",
      "poi_directions_map_url": "https://maps.google.com/?cid=8293547427755766427&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "secret-lake-park",
      "poi_latitude": "28.674132",
      "poi_longitude": "-81.32677199999999",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 407-262-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9e3-71f2-b0a4-d245e89fec67",
        "storage_key": "property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjTY90wlu54gRm7I8x3GZGHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_18ac29a8997d131f5f834285",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Lake Concord Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "95 Triplet Lake Dr, Casselberry, FL 32707, USA",
      "poi_short_description": "5-acre site with a sculpture garden, waterpark, art house, concerts, boardwalk & native gardens.",
      "poi_long_description": "5-acre site with a sculpture garden, waterpark, art house, concerts, boardwalk & native gardens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-01e5-742e-8b9e-3721395fb3b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-01e5-742e-8b9e-3721395fb3b5",
        "storage_key": "property/5712947535937536/019f1501-01e5-742e-8b9e-3721395fb3b5.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "http://www.casselberry.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10383120438964915295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-concord-park",
      "poi_latitude": "28.6717102",
      "poi_longitude": "-81.33769579999999",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-262-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9e3-71f2-b0a4-d245e89fec67",
        "storage_key": "property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-RBXBQFu54gRXwya8AZBGJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_a2ea8fa955fa2d41acfe8ff3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Red Bug Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3600 Red Bug Lake Rd, Casselberry, FL 32707, USA",
      "poi_short_description": "Tranquil green space featuring tennis areas, soccer fields, a playground, fishing & more.",
      "poi_long_description": "Tranquil green space featuring tennis areas, soccer fields, a playground, fishing & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-15cf-71a8-a451-7faeefe412fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-15cf-71a8-a451-7faeefe412fe",
        "storage_key": "property/5712947535937536/019f1501-15cf-71a8-a451-7faeefe412fe.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.seminolecountyfl.gov/locations/red-bug-lake-park.stml",
      "poi_directions_map_url": "https://maps.google.com/?cid=8713953632050658357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-bug-lake-park",
      "poi_latitude": "28.649086",
      "poi_longitude": "-81.289042",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 407-665-2190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9e3-71f2-b0a4-d245e89fec67",
        "storage_key": "property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwyZQ3_Ju54gRNbya66gu7ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0f8c80d228039e0d318ad893",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Wirz Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "806 Mark David Blvd, Casselberry, FL 32707, USA",
      "poi_short_description": "Family-friendly park, popular for swimming in its outdoor pool, plus featuring a playground and a paved trail for hiking and strolling.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-1568-762c-8009-9c13a9c6346b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-1568-762c-8009-9c13a9c6346b",
        "storage_key": "property/5712947535937536/019f1501-1568-762c-8009-9c13a9c6346b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.casselberry.org/index.aspx?NID=306",
      "poi_directions_map_url": "https://maps.google.com/?cid=16588903519756610151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wirz-park",
      "poi_latitude": "28.6507862",
      "poi_longitude": "-81.31536659999999",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 407-262-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9e3-71f2-b0a4-d245e89fec67",
        "storage_key": "property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJO93YH0Bu54gRZ-pRBNyfN-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0491e2273d7ccf8088b313a8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Pawmosa Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "140 Plumosa Ave, Casselberry, FL 32707, USA",
      "poi_short_description": "Clean and open area with separate spots for large and small dogs, plus benches and trees for shade.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-1e64-725c-865d-df6a867dbe4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-1e64-725c-865d-df6a867dbe4e",
        "storage_key": "property/5712947535937536/019f1501-1e64-725c-865d-df6a867dbe4e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.casselberry.org/index.aspx?NID=318",
      "poi_directions_map_url": "https://maps.google.com/?cid=5288783622726195602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pawmosa-dog-park",
      "poi_latitude": "28.6755258",
      "poi_longitude": "-81.3397051",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 407-262-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9e3-71f2-b0a4-d245e89fec67",
        "storage_key": "property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMWNu-f9t54gRkpl_Bq-IZUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_fc92c5ad061005d664f14e4c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Plumosa Oaks Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "140 Plumosa Ave, Casselberry, FL 32707, USA",
      "poi_short_description": "Leafy park with a playground, nature trail & basketball & volleyball courts, plus picnic facilities.",
      "poi_long_description": "Leafy park with a playground, nature trail & basketball & volleyball courts, plus picnic facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-0e6e-713a-8f42-6504feefae7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-0e6e-713a-8f42-6504feefae7a",
        "storage_key": "property/5712947535937536/019f1501-0e6e-713a-8f42-6504feefae7a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.casselberry.org/index.aspx?NID=345",
      "poi_directions_map_url": "https://maps.google.com/?cid=13603737604971271004&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plumosa-oaks-park",
      "poi_latitude": "28.6754857",
      "poi_longitude": "-81.3406073",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 407-262-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9e3-71f2-b0a4-d245e89fec67",
        "storage_key": "property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJX--2AwBy54gRXJPvqUYvyrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_303702aa9ea65cf1dd4f4f01",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Sunnytown Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "450 Ball Park Rd, Casselberry, FL 32707, USA",
      "poi_short_description": "Shaded park featuring a soccer area plus swings, slides, and a pirate ship play area.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-155e-7559-acda-b76b62af868d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-155e-7559-acda-b76b62af868d",
        "storage_key": "property/5712947535937536/019f1501-155e-7559-acda-b76b62af868d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.casselberry.org/index.aspx?NID=351",
      "poi_directions_map_url": "https://maps.google.com/?cid=7673241243328173766&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunnytown-park",
      "poi_latitude": "28.6657434",
      "poi_longitude": "-81.3449735",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-262-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9e3-71f2-b0a4-d245e89fec67",
        "storage_key": "property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxT7umPxx54gRxtZzmEHUfGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c1c6aeb3b1c9b54c9f17bfaf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Lake Hodge Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "870 Osceola Trail, Casselberry, FL 32707, USA",
      "poi_short_description": "Neighborhood park with a children's playground, tennis and basketball courts, and a dock for fishing.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-1c1d-7141-aa77-bcc9eb536513.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-1c1d-7141-aa77-bcc9eb536513",
        "storage_key": "property/5712947535937536/019f1501-1c1d-7141-aa77-bcc9eb536513.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.casselberry.org/index.aspx?NID=309",
      "poi_directions_map_url": "https://maps.google.com/?cid=2723336983234812545&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-hodge-park",
      "poi_latitude": "28.689762",
      "poi_longitude": "-81.3199135",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 407-262-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9e3-71f2-b0a4-d245e89fec67",
        "storage_key": "property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJr_iVvOlt54gRgRplsY48yyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_546ea85a6738b0cfe98208b2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Cady Way Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Cady Way Trail, Winter Park, FL 32792, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-1257-7168-8834-b41e6b912a85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-1257-7168-8834-b41e6b912a85",
        "storage_key": "property/5712947535937536/019f1501-1257-7168-8834-b41e6b912a85.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16783015496055194898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cady-way-trail",
      "poi_latitude": "28.5936778",
      "poi_longitude": "-81.3165441",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9e3-71f2-b0a4-d245e89fec67",
        "storage_key": "property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVZjjl5Jv54gREgU_Zqw_6eg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_b83d6e5169426016e49f956f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Howell Branch Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1205 Howell Branch Rd, Winter Park, FL 32789, USA",
      "poi_short_description": "Clean park featuring a pavilion, picnic tables, slides and playground.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-1d38-7296-a4c2-245cf059d128.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-1d38-7296-a4c2-245cf059d128",
        "storage_key": "property/5712947535937536/019f1501-1d38-7296-a4c2-245cf059d128.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://cityofwinterpark.org/departments/parks-recreation/parks-playgrounds/parks/howell-branch-preserve/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16173978972404794717&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "howell-branch-preserve",
      "poi_latitude": "28.6247132",
      "poi_longitude": "-81.339259",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 407-599-3397",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9e3-71f2-b0a4-d245e89fec67",
        "storage_key": "property/5712947535937536/019f14fe-b9e3-71f2-b0a4-d245e89fec67.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJI-H4hdVv54gRXUXTli6EdeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_be4bdfe2cead11132ee9bf36",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Altamonte Springs",
      "poi_type": "Transportation & Transit",
      "poi_address": "2741 S Ronald Reagan Blvd, Altamonte Springs, FL 32701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-a3fc-77e9-a091-f80229aeb1f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-a3fc-77e9-a091-f80229aeb1f3",
        "storage_key": "property/5712947535937536/019f14fe-a3fc-77e9-a091-f80229aeb1f3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.sunrail.com/station/altamonte-springs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4785753755214808591&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "altamonte-springs",
      "poi_latitude": "28.6640237",
      "poi_longitude": "-81.3565641",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-bc7c-778a-99a8-61acaa788687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-bc7c-778a-99a8-61acaa788687",
        "storage_key": "property/5712947535937536/019f14fe-bc7c-778a-99a8-61acaa788687.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJD2Te8e1x54gRDwYSMq9pakI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_cec3f96c663009a17441fa10",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Maitland Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "801 Orlando Ave, Maitland, FL 32751, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-aaa5-70b0-920b-1c1154b2bb16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-aaa5-70b0-920b-1c1154b2bb16",
        "storage_key": "property/5712947535937536/019f14fe-aaa5-70b0-920b-1c1154b2bb16.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sunrail.com/station/maitland/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18013411992765178987&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maitland-station",
      "poi_latitude": "28.634943",
      "poi_longitude": "-81.36216",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 855-724-5411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-bc7c-778a-99a8-61acaa788687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-bc7c-778a-99a8-61acaa788687",
        "storage_key": "property/5712947535937536/019f14fe-bc7c-778a-99a8-61acaa788687.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJhQ3F9LVx54gRa6SHrcR-_Pk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_c9ee538358868833b3cde668",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Winter Park",
      "poi_type": "Transportation & Transit",
      "poi_address": "Amtrak/SunRail Station, 148 W Morse Blvd, Winter Park, FL 32789, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-a4c5-71ce-bcca-1d75020396fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-a4c5-71ce-bcca-1d75020396fe",
        "storage_key": "property/5712947535937536/019f14fe-a4c5-71ce-bcca-1d75020396fe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=WPK",
      "poi_directions_map_url": "https://maps.google.com/?cid=859493728352157346&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winter-park",
      "poi_latitude": "28.5971064",
      "poi_longitude": "-81.35187719999999",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-bc7c-778a-99a8-61acaa788687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-bc7c-778a-99a8-61acaa788687",
        "storage_key": "property/5712947535937536/019f14fe-bc7c-778a-99a8-61acaa788687.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJy2hQWgh754gRoj4b_f2I7Qs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_2786b6c36e7fce1acbc98fcd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Longwood",
      "poi_type": "Transportation & Transit",
      "poi_address": "149 E, W Church Ave, Longwood, FL 32750, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-295b-758c-b7c3-c77d19dcc2be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-295b-758c-b7c3-c77d19dcc2be",
        "storage_key": "property/5712947535937536/019f1501-295b-758c-b7c3-c77d19dcc2be.webp",
        "width": 1280,
        "height": 728
      },
      "poi_business_url": "http://www.sunrail.com/station/longwood/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11750318564763892458&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "longwood",
      "poi_latitude": "28.70142439999999",
      "poi_longitude": "-81.3452089",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 855-724-5411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-bc7c-778a-99a8-61acaa788687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-bc7c-778a-99a8-61acaa788687",
        "storage_key": "property/5712947535937536/019f14fe-bc7c-778a-99a8-61acaa788687.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJdx5kgnRy54gR6vptknqEEaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_6321b541c18091a3dea6b765",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Lake Mary Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "2200 W Lake Mary Blvd, Lake Mary, FL 32746, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-29c8-71fb-b2e1-458c3cb8df88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-29c8-71fb-b2e1-458c3cb8df88",
        "storage_key": "property/5712947535937536/019f1501-29c8-71fb-b2e1-458c3cb8df88.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sunrail.com/station/lake-mary/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5475754148572992872&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-mary-station",
      "poi_latitude": "28.7586649",
      "poi_longitude": "-81.3183008",
      "poi_miles_from_property": "10.8 mi",
      "poi_walking_minutes": "4 hours 0 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 855-724-5411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-bc7c-778a-99a8-61acaa788687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-bc7c-778a-99a8-61acaa788687",
        "storage_key": "property/5712947535937536/019f14fe-bc7c-778a-99a8-61acaa788687.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJQVQB2klt54gRaJUQ52LJ_Us",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_fa2e69211327d26fe8c237d6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Sanford Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "2720 W State Rd 46, Sanford, FL 32771, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-2d9a-7717-9a1e-edfa8c72bb65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-2d9a-7717-9a1e-edfa8c72bb65",
        "storage_key": "property/5712947535937536/019f1501-2d9a-7717-9a1e-edfa8c72bb65.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.sunrail.com/station/sanford/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1785057401900985730&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sanford-station",
      "poi_latitude": "28.813477",
      "poi_longitude": "-81.298119",
      "poi_miles_from_property": "14.8 mi",
      "poi_walking_minutes": "5 hours 26 mins",
      "poi_biking_minutes": "1 hour 35 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-bc7c-778a-99a8-61acaa788687.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-bc7c-778a-99a8-61acaa788687",
        "storage_key": "property/5712947535937536/019f14fe-bc7c-778a-99a8-61acaa788687.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJv7dEDlUS54gRgm391z_MxRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_acdcb6c0402377a19fe9f294",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Lynx Central",
      "poi_type": "Transportation & Transit",
      "poi_address": "455 N Garland Ave, Orlando, FL 32801, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-30b5-74a9-8b07-0ba9ed231def.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-30b5-74a9-8b07-0ba9ed231def",
        "storage_key": "property/5712947535937536/019f1501-30b5-74a9-8b07-0ba9ed231def.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.golynx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5762862083644479993&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lynx-central",
      "poi_latitude": "28.548485",
      "poi_longitude": "-81.381256",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 407-841-5969",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-457e-718b-a710-d1c8acbea48f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-457e-718b-a710-d1c8acbea48f",
        "storage_key": "property/5712947535937536/019f1501-457e-718b-a710-d1c8acbea48f.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1ZcEsvl654gR-VkyOYjM-U8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_256d96b11e7956c80707ac11",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Orlando International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Jeff Fuqua Blvd, Orlando, FL 32827, USA",
      "poi_short_description": "High-traffic airport with a hub-&-spoke design features an on-site hotel & lots of public artwork.",
      "poi_long_description": "High-traffic airport with a hub-&-spoke design features an on-site hotel & lots of public artwork.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-3007-77f8-ba4c-78edfe31a9bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-3007-77f8-ba4c-78edfe31a9bf",
        "storage_key": "property/5712947535937536/019f1501-3007-77f8-ba4c-78edfe31a9bf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://flymco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12486996560901693805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-international-airport",
      "poi_latitude": "28.4244422",
      "poi_longitude": "-81.3104595",
      "poi_miles_from_property": "23.3 mi",
      "poi_walking_minutes": "8 hours 33 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 407-825-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9f4-76f8-9220-03311c9d23b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9f4-76f8-9220-03311c9d23b6",
        "storage_key": "property/5712947535937536/019f14fe-b9f4-76f8-9220-03311c9d23b6.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ85K0xidj54gRbeERlDa5Sq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_6c5ea9a3020a15b98fd251e0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Casselberry City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "95 Triplet Lake Dr, Casselberry, FL 32707, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-32b4-7445-8b01-6f51067f0713.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-32b4-7445-8b01-6f51067f0713",
        "storage_key": "property/5712947535937536/019f1501-32b4-7445-8b01-6f51067f0713.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.casselberry.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14840537516123379666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "casselberry-city-hall",
      "poi_latitude": "28.6716713",
      "poi_longitude": "-81.337057",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 407-262-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9da-7428-80ec-2c97c8d56835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9da-7428-80ec-2c97c8d56835",
        "storage_key": "property/5712947535937536/019f14fe-b9da-7428-80ec-2c97c8d56835.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHeFQAdBv54gR0ldkDD4u9M0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_3e5180d1b700ab720ac420bd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Seminole County Clerk and Comptroller",
      "poi_type": "Major Employers & Offices",
      "poi_address": "376 Wilshire Blvd, Casselberry, FL 32707, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-35c2-727a-990c-6579760f3f4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-35c2-727a-990c-6579760f3f4d",
        "storage_key": "property/5712947535937536/019f1501-35c2-727a-990c-6579760f3f4d.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.seminoleclerk.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7624121165160596474&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seminole-county-clerk-and-comptroller",
      "poi_latitude": "28.6491454",
      "poi_longitude": "-81.33021509999999",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 407-665-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9da-7428-80ec-2c97c8d56835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9da-7428-80ec-2c97c8d56835",
        "storage_key": "property/5712947535937536/019f14fe-b9da-7428-80ec-2c97c8d56835.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh9yEwiJu54gR-kPvLc5Rzmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_fb545368fcdfad7db2652226",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Seminole County Government",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1101 E 1st St, Sanford, FL 32771, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-37cc-730a-a437-29992c65668b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-37cc-730a-a437-29992c65668b",
        "storage_key": "property/5712947535937536/019f1501-37cc-730a-a437-29992c65668b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.seminolecountyfl.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14470805415337174054&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seminole-county-government",
      "poi_latitude": "28.8109222",
      "poi_longitude": "-81.25557479999999",
      "poi_miles_from_property": "15.0 mi",
      "poi_walking_minutes": "5 hours 32 mins",
      "poi_biking_minutes": "1 hour 38 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 407-665-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9da-7428-80ec-2c97c8d56835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9da-7428-80ec-2c97c8d56835",
        "storage_key": "property/5712947535937536/019f14fe-b9da-7428-80ec-2c97c8d56835.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE74GmoET54gRJqT4Ctug0sg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_295f621d0ac146332f17a0c3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Seminole State College - Sanford/Lake Mary Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Weldon Blvd, Sanford, FL 32773, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-39b0-7089-ac76-42c472080ee3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-39b0-7089-ac76-42c472080ee3",
        "storage_key": "property/5712947535937536/019f1501-39b0-7089-ac76-42c472080ee3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.seminolestate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9346347928205288088&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seminole-state-college---sanfordlake-mary-campus",
      "poi_latitude": "28.7449505",
      "poi_longitude": "-81.30439369999999",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 407-708-4722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9ca-7370-be2c-2b128af15cd8",
        "storage_key": "property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi3f0tSJt54gRmGLi7-vltIE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_cf4713e8cc29e275e931c7e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Orlando Sanford International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 Red Cleveland Blvd, Sanford, FL 32773, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-38fc-702a-bd6d-64425c32e36a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-38fc-702a-bd6d-64425c32e36a",
        "storage_key": "property/5712947535937536/019f1501-38fc-702a-bd6d-64425c32e36a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://flysfb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10623798462706659909&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-sanford-international-airport",
      "poi_latitude": "28.7760155",
      "poi_longitude": "-81.234467",
      "poi_miles_from_property": "14.0 mi",
      "poi_walking_minutes": "5 hours 8 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 407-585-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9f4-76f8-9220-03311c9d23b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9f4-76f8-9220-03311c9d23b6",
        "storage_key": "property/5712947535937536/019f14fe-b9f4-76f8-9220-03311c9d23b6.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5d7ffVJr54gRRbL4HmpQb5M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_04a74c478e88acbfd4f2d5fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "AdventHealth Winter Park",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 N Lakemont Ave, Winter Park, FL 32792, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-3906-729a-b963-4189ff119a42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-3906-729a-b963-4189ff119a42",
        "storage_key": "property/5712947535937536/019f1501-3906-729a-b963-4189ff119a42.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.adventhealth.com/hospital/adventhealth-winter-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15842510593159667495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-winter-park",
      "poi_latitude": "28.5983771",
      "poi_longitude": "-81.3268672",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 407-646-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9ca-7370-be2c-2418f709a9ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9ca-7370-be2c-2418f709a9ef",
        "storage_key": "property/5712947535937536/019f14fe-b9ca-7370-be2c-2418f709a9ef.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJU7yQJO9v54gRJx-lf3Ln29s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_1535840221a79934d00b98c4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "AdventHealth Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "900 Hope Way, Altamonte Springs, FL 32714, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-abc1-7312-bb53-1d05b476b30f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-abc1-7312-bb53-1d05b476b30f",
        "storage_key": "property/5712947535937536/019f14fe-abc1-7312-bb53-1d05b476b30f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.adventhealth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13416548737757089436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-headquarters",
      "poi_latitude": "28.6417257",
      "poi_longitude": "-81.4142406",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 407-357-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9fc-7160-b11a-32944c092560",
        "storage_key": "property/5712947535937536/019f14fe-b9fc-7160-b11a-32944c092560.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUYkETSRx54gRnA66Of4nMbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_b499ee23988595edf43cdebe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Rollins College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 Holt Ave, Winter Park, FL 32789, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-82c2-75e8-85bb-c04dc60bae4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-82c2-75e8-85bb-c04dc60bae4a",
        "storage_key": "property/5712947535937536/019f14fe-82c2-75e8-85bb-c04dc60bae4a.webp",
        "width": 591,
        "height": 394
      },
      "poi_business_url": "https://www.rollins.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11645901038757432440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rollins-college",
      "poi_latitude": "28.5929697",
      "poi_longitude": "-81.35161260000001",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 407-646-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9ca-7370-be2c-2b128af15cd8",
        "storage_key": "property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM3OuAQVw54gReEx9yEqNnqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_aca0aa89c8274f1d9184e818",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "University of Central Florida",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4000 Central Florida Blvd, Orlando, FL 32816, USA",
      "poi_short_description": "Research university set on 1,415 acres with a lake & woodlands.",
      "poi_long_description": "Research university set on 1,415 acres with a lake & woodlands.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJX0kKal1o54gRq5vHs5Kb1V8/photos/AaVGc3kkLaZS8E-ChviyCQ52UiLZkjWZSw9M_e7chNbzU5SUlULX8CCXn1rdcy-fDI5_W8uoV5knFNWQsyzR-J-CM4JXfiNgzIdGOEICZ3LGMTxEnjkog2skl6j6K0F20KWOHz1VHcknhAqcPwZgzWVW7J3Muromfq23hcWqqgbBowd_Rc_llwtu6hTSOZgYFTQLZtIeqcU452u_x7lJ2ut_76cBmfe5WS-RPpSuOJyKaoL2lz4K-oN-GNlCuBVV1tkWjftqwFgCW3KADmlPmSv_WGIQJ6Yrk6r8ImEUVE__pebAEOYomwhZ6efaXHB3gMVUyAzAOnW_14RvbxEWWzuS3YB44yqzT2R34qg7IDcnuChsnmmQtsaV-JQ77TAWYPjWN7oRNKen203nDrAwZU3YihIGnXIhQZR49-ZLrqFbyaDWnA/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4745&maxHeightPx=4800",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ucf.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6905596658026257323&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-central-florida",
      "poi_latitude": "28.6024274",
      "poi_longitude": "-81.2000599",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 407-823-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9ca-7370-be2c-2b128af15cd8",
        "storage_key": "property/5712947535937536/019f14fe-b9ca-7370-be2c-2b128af15cd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJX0kKal1o54gRq5vHs5Kb1V8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_54bef625dac67f5e03dfd1a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "poi_name": "Orlando Health Orlando Regional Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "52 W Underwood St, Orlando, FL 32806, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f1501-3b5c-7346-868f-2018c710e884.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-3b5c-7346-868f-2018c710e884",
        "storage_key": "property/5712947535937536/019f1501-3b5c-7346-868f-2018c710e884.webp",
        "width": 1280,
        "height": 935
      },
      "poi_business_url": "https://www.orlandohealth.com/facilities/orlando-regional-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=24878703848122848&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-health-orlando-regional-medical-center",
      "poi_latitude": "28.526485",
      "poi_longitude": "-81.3778912",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 321-841-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14fe-b9ca-7370-be2c-2418f709a9ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-b9ca-7370-be2c-2418f709a9ef",
        "storage_key": "property/5712947535937536/019f14fe-b9ca-7370-be2c-2418f709a9ef.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-9TcQw9754gR4OlWoQxjWAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    }
  ],
  "office_hours": [
    {
      "id": "custom_5983e74a-2b02-484f-a1be-9cb6ab9a3e77",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_78b9c913-ee15-48f8-be63-0274ae70f464",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_57984a3d-b3ce-4336-b0d7-81838b99177d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_03efb05c-64e6-4584-9efc-e43e064702f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_aab5cd30-c927-4c10-a091-20433b5c67a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_abd2d45c-5a2a-4b04-8f71-5955533a0910",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_de5e0982-0a93-42f0-88e1-70a0b477e4d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "rating": "4.0",
      "name": "Kyra Edwards",
      "text": "Onyx Winter Park has a great view, and the clubhouse is truly amazing! It’s a blessing that once a month, management throws something special for the residents, and they be intentional on making sure all residents know! Also, management checks on residents often, which is grandly appreciated! We are like Mcdonald’s “We’re Loving It!”.  Kassaundra Edwards",
      "date": "2026-06-18",
      "title": ""
    },
    {
      "id": "custom_0110cad2-86d5-4335-9c0d-9971a8e82d78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "rating": "5.0",
      "name": "Gabriella Pivonka",
      "text": "Heather is truly amazing! She was incredibly kind and patient throughout the entire leasing process. She answered all of my questions and made me feel completely comfortable asking anything I needed to. Her support made a very difficult time so much smoother. Edwin was also very helpful and answered all my questions when I spoke with him on the phone. Just moved in 2 weeks ago and already enjoy living here. The apartment was beautiful and clean. So far no issues :)",
      "date": "2025-12-02",
      "title": ""
    },
    {
      "id": "custom_b1a71714-cda0-49af-af73-e0aad3de2aff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "rating": "5.0",
      "name": "Gail Hayden",
      "text": "We moved here in Nov. 2025.  We love it. Management is great and does a lot for the residents. The grounds are well kept, the complex is clean,safe and quiet. Close to shopping,take out restaurants and etc.  Maintenance is very responsive. Our apartment was immaculate when we moved in. Office staff is top notch and very patient. Our apartment overlooks water and the ducks are a joy to watch. If you are looking for a really nice place to live I highly recommend Onyx.",
      "date": "2026-02-14",
      "title": ""
    },
    {
      "id": "custom_7060a7e1-cb2e-481a-84e2-eb05cf310626",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "rating": "5.0",
      "name": "Mike Lassig",
      "text": "Edwin was great helping me set up my apartment. I needed to move quickly from South Carolina and he made everything smooth and easy. The rest of the staff I briefly spoke with on the phone were also very helpful!",
      "date": "2025-12-03",
      "title": ""
    },
    {
      "id": "custom_ebdba8bb-7986-4949-be8e-781ed0dd3ae5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "rating": "5.0",
      "name": "Arthur Martinez",
      "text": "Laquita did a great job showing me the units I was interested in and answering all my questions. She was professional, friendly, and made the whole experience easy. The property is in a great area and everything looked very clean and well maintained.",
      "date": "2026-03-30",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_2e6d0baaf154adf4e7f4a4a6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f14c3-d782-7105-bd7e-4a9976b59498.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-d782-7105-bd7e-4a9976b59498",
        "storage_key": "property/5712947535937536/019f14c3-d782-7105-bd7e-4a9976b59498.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Onyx Winter Park - Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/BLhhdgURdvw"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-c480-72c2-a0f0-7161d679bc16",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "onyx-winter-park",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536"
    },
    {
      "lead_collector_id": "0198aa45-c4e3-74fb-acd2-a4197c97d7ef",
      "lead_source": "FACEBOOK_ADS",
      "name": "onyx-winter-park",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536"
    },
    {
      "lead_collector_id": "0198aa45-c546-74de-a04c-ce6051bcba7d",
      "lead_source": "LANDING_PAGE",
      "name": "onyx-winter-park",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "page_item_url": "onyx-winter-park-apartments-in-unit-laundry-casselberry-29",
      "search_query": "apartments with in unit laundry Casselberry FL",
      "category": "Amenity",
      "h1_title": "Casselberry Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover the convenience of in-unit laundry at Onyx Winter Park. Enjoy modern living in Casselberry, FL, with stylish amenities and lake views.",
      "page_copy": "Experience the ultimate convenience at Onyx Winter Park, where our Casselberry, FL apartments feature the modern luxury of in-unit laundry. Located in the serene Lake Howell neighborhood, these residences offer the perfect balance of comfort and style. Imagine coming home to stunning lake views and a suite of amenities, including a state-of-the-art fitness center, pet spa, and vibrant clubhouse. Whether you prefer a studio or a two-bedroom floor plan, each apartment is equipped with high-speed internet, a range, and a dishwasher for your utmost convenience.\n\nOnyx Winter Park isn’t just about upscale living; it’s about making life easier. With in-unit laundry facilities, you'll save time and enjoy more of what our community has to offer. Step outside to indulge in our picnic area or stay inside and take advantage of our walk-up access. Situated in the charming community of Seminole County, our apartments are designed to meet your every need. Discover why our residents love calling Onyx Winter Park home and see the difference of having in-unit laundry today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with modern furniture and abstract art.",
        "public_id": "019f6c10-0b55-741d-b06f-ed490498fe09",
        "storage_key": "property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Casselberry FL Apartments with In-Unit Laundry",
      "seo_description": "Discover Casselberry, FL apartments with in-unit laundry at Onyx Winter Park. Enjoy a blend of comfort and convenience with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "page_item_url": "onyx-winter-park-air-conditioned-apartments-lake-howell-406",
      "search_query": "air conditioned apartments near Lake Howell FL",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near Lake Howell",
      "h2_subtitle": "Experience air-conditioned comfort at Onyx Winter Park. Located near Lake Howell in Casselberry, FL, our apartments offer modern amenities and serene lake views.",
      "page_copy": "Onyx Winter Park offers a refreshing retreat with air-conditioned apartments perfectly situated near Lake Howell in Casselberry, FL. Our community provides residents with a blend of comfort and modern living, highlighted by a range of impressive amenities. Whether you're looking for a cozy studio or a spacious two-bedroom option, you'll appreciate the stunning lake views, high-speed internet access, and modern appliances such as a range and dishwasher that come standard in each unit.\n\nLiving near Lake Howell means embracing a lifestyle of relaxation and ease, and our air-conditioned apartments ensure you remain comfortable year-round. Beyond individual unit features, residents enjoy a vibrant clubhouse, a fully-equipped fitness center, and a pet spa for their furry friends. Outdoor enthusiasts can take advantage of the picnic area or explore the nearby surroundings of beautiful Seminole County. Discover air-conditioned luxury at Onyx Winter Park and enjoy every season in style.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with modern furniture and abstract art.",
        "public_id": "019f6c10-0b55-741d-b06f-ed490498fe09",
        "storage_key": "property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apts Near Lake Howell, FL",
      "seo_description": "Find comfortable, air-conditioned apartments near Lake Howell, FL, at Onyx Winter Park. Enjoy modern living with stunning views and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "page_item_url": "onyx-winter-park-pet-friendly-apartments-pool-seminole-county-658",
      "search_query": "pet friendly apartments with pool Seminole County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Pool",
      "h2_subtitle": "Welcome to Onyx Winter Park, pet-friendly apartments with a pool in Seminole County. Enjoy modern amenities and a great location.",
      "page_copy": "Discover the ideal living experience at Onyx Winter Park, where pet-friendly apartments with a pool make living in Seminole County a delight. Our community caters to both you and your furry friends, offering amenities such as a state-of-the-art pet spa and spacious grounds for walks and play. The sparkling pool serves as the perfect spot to relax and unwind, with scenic views of Lake Howell adding an extra touch of tranquility to your everyday routine.\n\nOnyx Winter Park combines convenience and style with various floor plans, including studios and two-bedroom options. Each home is equipped with high-speed internet access, modern appliances like a range and dishwasher, and the comfort of air conditioning. Engage with community life at our vibrant clubhouse or stay fit at the on-site fitness center. Located in the heart of Seminole County, just minutes from Casselberry, FL, Onyx Winter Park is more than an apartment—it's a lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with modern furniture and abstract art.",
        "public_id": "019f6c10-0b55-741d-b06f-ed490498fe09",
        "storage_key": "property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Pool in Seminole County",
      "seo_description": "Find pet-friendly apartments with a pool in Seminole County at Onyx Winter Park. Enjoy great amenities and a vibrant community lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "page_item_url": "onyx-winter-park-dog-friendly-apartments-fitness-center-32707-38",
      "search_query": "dog-friendly apartments with fitness center 32707",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments with Fitness Center",
      "h2_subtitle": "Onyx Winter Park in 32707 offers dog-friendly apartments complete with a fitness center. Enjoy modern living with your furry friend in Casselberry, FL.",
      "page_copy": "Welcome to Onyx Winter Park, where dog-friendly apartments meet modern living in the 32707 area. Our community in Casselberry, FL, is designed with both you and your pup in mind. With our dedicated pet spa and plenty of green spaces, your furry friend will feel right at home. Stay active with our fully-equipped fitness center, perfect for maintaining a healthy lifestyle, all while enjoying the comfort of your stylish apartment.\n\nOur range of floor plans, including both studios and two-bedroom options, are outfitted with high-speed internet, a range, and a dishwasher—ensuring a convenient living experience. Beyond your apartment, socialize at our vibrant clubhouse, relax in our picnic area, or take in the scenic views of Lake Howell. Located in Seminole County, Onyx Winter Park offers an idyllic setting where you and your canine companion can thrive. Embrace the best of both indoor comfort and outdoor adventure right here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with modern furniture and abstract art.",
        "public_id": "019f6c10-0b55-741d-b06f-ed490498fe09",
        "storage_key": "property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments & Fitness Center in 32707",
      "seo_description": "Discover dog-friendly apartments with a fitness center at Onyx Winter Park in 32707. Enjoy an active lifestyle in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "page_item_url": "onyx-winter-park-apartments-modern-kitchens-dishwasher-casselberry-354",
      "search_query": "apartments with modern kitchens and dishwasher Casselberry",
      "category": "Amenity",
      "h1_title": "Apartments with Modern Kitchens in Casselberry",
      "h2_subtitle": "Explore Onyx Winter Park's apartments featuring modern kitchens and a dishwasher in Casselberry, FL. Enjoy luxury living at its best.",
      "page_copy": "At Onyx Winter Park, we offer apartments equipped with modern kitchens and a dishwasher, perfectly situated in the heart of Casselberry, FL. Each kitchen is designed with functionality and style in mind, featuring sleek appliances and ample space to indulge your culinary passions. Whether you're putting together quick weeknight dinners or hosting friends, our kitchens provide everything you need.\n\nOur community isn't just about practical amenities—it's about lifestyle, too. Choose from a variety of floor plans, including studios and two-bedroom layouts, each offering stunning lake views and high-speed internet access. Outside of your apartment, enjoy access to our vibrant clubhouse, a refreshing pool, and a well-equipped fitness center. Situated in beautiful Seminole County, Onyx Winter Park combines convenience, comfort, and modern living, making it the ultimate place to call home in Casselberry.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with modern furniture and abstract art.",
        "public_id": "019f6c10-0b55-741d-b06f-ed490498fe09",
        "storage_key": "property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Kitchens & Dishwasher Apartments in Casselberry",
      "seo_description": "Find apartments with modern kitchens and a dishwasher in Casselberry, FL, at Onyx Winter Park. Enjoy elegant design and superb amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "page_item_url": "onyx-winter-park-studio-apartments-lake-howell-392",
      "search_query": "studio apartments Lake Howell",
      "category": "Floorplan",
      "h1_title": "Studio Apartments Near Lake Howell",
      "h2_subtitle": "Discover stylish studio apartments at Onyx Winter Park, located by the scenic Lake Howell. Ideal for modern living in Casselberry, FL.",
      "page_copy": "Welcome to Onyx Winter Park, where stylish studio apartments near Lake Howell offer an extraordinary living experience. Each studio is crafted with open, airy designs that maximize space and natural light, creating a serene atmosphere perfect for relaxation or work-from-home days. These studios boast modern finishes and are equipped with high-speed internet access, making them both practical and comfortable.\n\nResidents of Onyx Winter Park can enjoy a variety of modern amenities, including a fully-equipped fitness center, a vibrant clubhouse, and a refreshing pool with stunning lake views. These features, combined with the convenience of a dishwasher and contemporary appliances, ensure a comfortable lifestyle. Located in scenic Seminole County, near bustling Casselberry, FL, our community offers the perfect blend of tranquility and modern convenience. Step into your new studio apartment today and experience the best of lakefront living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with modern furniture and abstract art.",
        "public_id": "019f6c10-0b55-741d-b06f-ed490498fe09",
        "storage_key": "property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments by Lake Howell, Casselberry",
      "seo_description": "Explore studio apartments at Onyx Winter Park, located near Lake Howell. Enjoy modern living with lake views and superb amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "page_item_url": "onyx-winter-park-1-bedroom-apartment-casselberry-fl-396",
      "search_query": "1 bedroom apartment Casselberry FL",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartment in Casselberry, FL",
      "h2_subtitle": "Find your ideal 1 bedroom apartment at Onyx Winter Park in Casselberry, FL. Experience modern living with top-notch amenities in Seminole County.",
      "page_copy": "Experience elevated living with a 1 bedroom apartment at Onyx Winter Park, nestled in the vibrant community of Casselberry, FL. Each apartment features spacious layouts with stylish finishes and high-speed internet access, catering to both comfort and efficiency. Enjoy cooking in a modern kitchen complete with a dishwasher and range, simplifying daily routines and enhancing your living experience.\n\nBeyond your apartment, Onyx Winter Park provides an array of exceptional amenities, including a state-of-the-art fitness center and a picturesque picnic area. Our vibrant clubhouse is perfect for socializing, while the peaceful views of Lake Howell offer a tranquil escape. Located in the heart of Seminole County, our community harmonizes serene surroundings with convenient access to local attractions, making it the perfect place to call home. Discover the optimal blend of luxury and function in your new 1 bedroom apartment today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with modern furniture and abstract art.",
        "public_id": "019f6c10-0b55-741d-b06f-ed490498fe09",
        "storage_key": "property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartment in Casselberry, FL",
      "seo_description": "Discover a 1 bedroom apartment at Onyx Winter Park in Casselberry, FL. Enjoy modern amenities and lake views in a serene setting.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "page_item_url": "onyx-winter-park-2-bedroom-apartments-seminole-county-698",
      "search_query": "2 bedroom apartments Seminole County",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Seminole County",
      "h2_subtitle": "Discover spacious 2 bedroom apartments at Onyx Winter Park in Seminole County. Enjoy modern amenities and beautiful lake views in Casselberry, FL.",
      "page_copy": "Located in scenic Seminole County, Onyx Winter Park offers spacious 2 bedroom apartments that cater to those seeking comfort and style. Each apartment is thoughtfully designed with modern finishes, providing ample space for both relaxation and productivity. With high-speed internet access, contemporary kitchens boasting a range and dishwasher, you'll find daily life convenient and enjoyable.\n\nAt Onyx Winter Park, residents are surrounded by a suite of amenities. Our fitness center and pet spa support an active lifestyle, while the vibrant clubhouse and picnic areas offer perfect spots for social gatherings. Enjoy peaceful moments with stunning views of Lake Howell, right from the comfort of your home. Situated in the heart of Casselberry, FL, our community blends the tranquility of lakefront living with easy access to local attractions, making it a premier choice in Seminole County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with modern furniture and abstract art.",
        "public_id": "019f6c10-0b55-741d-b06f-ed490498fe09",
        "storage_key": "property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Seminole County, FL",
      "seo_description": "Explore 2 bedroom apartments at Onyx Winter Park in Seminole County. Enjoy modern amenities and lake views in Casselberry, FL.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "page_item_url": "onyx-winter-park-apartments-near-rollins-college-607",
      "search_query": "apartments near Rollins College Winter Park",
      "category": "School",
      "h1_title": "Apartments Near Rollins College",
      "h2_subtitle": "Explore Onyx Winter Park, offering upscale apartments just minutes from Rollins College in Winter Park. Ideal for students and faculty alike.",
      "page_copy": "Discover the ideal living space at Onyx Winter Park, featuring modern apartments near Rollins College in Winter Park. Our community offers a range of floor plans, including studios and two-bedroom options, perfect for students and faculty seeking convenient proximity to campus. Each apartment is designed with comfort in mind, equipped with high-speed internet access and modern appliances, including a dishwasher and range, making daily living hassle-free.\n\nResidents at Onyx Winter Park enjoy premium amenities such as a fitness center, perfect for unwinding after classes, and a vibrant clubhouse where you can meet and socialize with fellow residents. The scenic views of Lake Howell provide a peaceful backdrop, optimal for relaxation and study. Located in bustling Casselberry, FL, these apartments offer an excellent blend of convenience and comfort, making them a great choice for those connected to Rollins College, just a short drive away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with modern furniture and abstract art.",
        "public_id": "019f6c10-0b55-741d-b06f-ed490498fe09",
        "storage_key": "property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rollins College, Winter Park",
      "seo_description": "Find modern apartments near Rollins College at Onyx Winter Park. Enjoy convenient living with superb amenities close to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "page_item_url": "onyx-winter-park-apartments-close-to-everglades-university-540",
      "search_query": "apartments close to Everglades University Orlando",
      "category": "School",
      "h1_title": "Apartments Close to Everglades University",
      "h2_subtitle": "Discover Onyx Winter Park, offering appliances ideal for students seeking apartments close to Everglades University Orlando.",
      "page_copy": "Welcome to Onyx Winter Park, where you can find contemporary apartments close to Everglades University in Orlando. Perfectly suited for students and professionals looking for convenience and style, our community offers diverse floor plans, including studios and two-bedroom models. Each apartment is outfitted with premium features, including high-speed internet access and modern kitchens equipped with dishwashers and ranges, ensuring a seamless living experience.\n\nSituated in the welcoming city of Casselberry, FL, Onyx Winter Park provides an array of enticing amenities designed for an enriching lifestyle. From a top-notch fitness center and serene picnic area to a lively clubhouse, residents can enjoy both social and private moments. With beautiful views of Lake Howell, our community presents an excellent balance of tranquility and accessibility, making it a strategic choice for those studying or working at Everglades University in nearby Orlando.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with modern furniture and abstract art.",
        "public_id": "019f6c10-0b55-741d-b06f-ed490498fe09",
        "storage_key": "property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Everglades University, Orlando",
      "seo_description": "Explore Onyx Winter Park apartments close to Everglades University Orlando. Enjoy modern amenities and serene lake views.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "page_item_url": "onyx-winter-park-apartments-near-valencia-college-474",
      "search_query": "apartments near Valencia College Winter Park",
      "category": "School",
      "h1_title": "Apartments Near Valencia College",
      "h2_subtitle": "Onyx Winter Park offers excellent apartment living near Valencia College Winter Park. Ideal for students seeking comfort and convenience.",
      "page_copy": "Find your perfect home at Onyx Winter Park, strategically located near Valencia College in Winter Park. Our community offers a variety of floor plans, including spacious studios and two-bedroom apartments, ideal for students, faculty, and staff. Each unit is equipped with high-speed internet and modern appliances such as a dishwasher and range, making it perfect for both studying and day-to-day living.\n\nBeyond the comforts of apartment living, Onyx Winter Park boasts an array of amenities designed to enhance your lifestyle. Residents can take advantage of our fitness center, relax in the vibrant clubhouse, or enjoy a leisurely day in the scenic picnic area overlooking Lake Howell. Located in the bustling area of Casselberry, FL, Onyx Winter Park ensures easy access to Valencia College Winter Park, making it a prime choice for those seeking convenience amidst serene surroundings.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with modern furniture and abstract art.",
        "public_id": "019f6c10-0b55-741d-b06f-ed490498fe09",
        "storage_key": "property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Valencia College, Winter Park",
      "seo_description": "Discover Onyx Winter Park, offering apartments near Valencia College, Winter Park. Enjoy modern living with easy access to campus amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "page_item_url": "onyx-winter-park-apartments-near-socrates-prep-school-504",
      "search_query": "apartments close to Socrates Preparatory School FL",
      "category": "School",
      "h1_title": "Apartments Close to Socrates Prep School",
      "h2_subtitle": "Explore Onyx Winter Park, offering modern apartments just a short drive from Socrates Preparatory School in FL. Ideal for families and faculty alike.",
      "page_copy": "Welcome to Onyx Winter Park, where comfort and convenience meet near Socrates Preparatory School in FL. Our community features a selection of spacious floor plans ranging from cozy studios to expansive two-bedroom apartments, perfect for families and professionals alike. Each apartment is equipped with high-speed internet and modern conveniences like a dishwasher and range, ensuring an efficient and comfortable living experience.\n\nNestled in the charming area of Casselberry, FL, Onyx Winter Park boasts amenities designed to enrich your lifestyle. Enjoy energizing workouts in our fitness center or host gatherings in the vibrant clubhouse. The scenic views of Lake Howell provide a tranquil setting, ideal for relaxation or a family picnic. Conveniently situated close to Socrates Preparatory School, our community offers an excellent environment for those seeking both ease of access and a peaceful living space.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with modern furniture and abstract art.",
        "public_id": "019f6c10-0b55-741d-b06f-ed490498fe09",
        "storage_key": "property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Socrates Prep School, FL",
      "seo_description": "Discover Onyx Winter Park, offering apartments close to Socrates Preparatory School, FL. Enjoy modern amenities and easy access to education.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "page_item_url": "onyx-winter-park-apartments-near-park-maitland-school-480",
      "search_query": "apartments near Park Maitland School Seminole County",
      "category": "School",
      "h1_title": "Apartments Near Park Maitland School",
      "h2_subtitle": "Discover premium living at Onyx Winter Park, offering apartments near Park Maitland School in Seminole County.",
      "page_copy": "At Onyx Winter Park, find your ideal home in a community thoughtfully positioned near Park Maitland School in Seminole County. With a variety of floor plans ranging from stylish studios to spacious two-bedroom apartments, we cater to families and professionals alike. Each unit features modern conveniences, including high-speed internet and well-equipped kitchens with a dishwasher and range, ensuring a comfortable and practical lifestyle.\n\nOur community, located in the scenic Casselberry, FL, is rich with amenities that provide both tranquility and engagement. Enjoy the serene views of Lake Howell, or take advantage of our inviting clubhouse and picnic area for social gatherings. Parents and faculty members find Onyx Winter Park particularly appealing due to its proximity to Park Maitland School, offering not just convenience, but a welcoming neighborhood to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with modern furniture and abstract art.",
        "public_id": "019f6c10-0b55-741d-b06f-ed490498fe09",
        "storage_key": "property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Park Maitland School, FL",
      "seo_description": "Explore Onyx Winter Park, offering apartments near Park Maitland School in Seminole County. Modern amenities and easy access to education.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "page_item_url": "onyx-winter-park-apartments-near-howell-branch-academy-238",
      "search_query": "apartments close to Howell Branch Academy Casselberry",
      "category": "School",
      "h1_title": "Apartments Close to Howell Branch Academy",
      "h2_subtitle": "Discover Onyx Winter Park, offering convenient living with apartments close to Howell Branch Academy in Casselberry.",
      "page_copy": "Experience the comfort of living at Onyx Winter Park, ideally situated near Howell Branch Academy in the vibrant community of Casselberry, FL. Offering a range of floor plans from cozy studios to generous two-bedroom units, our apartments are perfect for families, students, and faculty alike. Equipped with high-speed internet and modern appliances including a dishwasher and range, each apartment is designed to support a seamless lifestyle.\n\nEnjoy the host of amenities available within the Onyx Winter Park community. Get in a good workout at our modern fitness center, unwind at the award-winning clubhouse, or enjoy a leisurely afternoon in our peaceful picnic area by Lake Howell. With the proximity to Howell Branch Academy, residents benefit from both a quiet neighborhood atmosphere and the convenience of nearby educational facilities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with modern furniture and abstract art.",
        "public_id": "019f6c10-0b55-741d-b06f-ed490498fe09",
        "storage_key": "property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Howell Branch Academy, FL",
      "seo_description": "Discover Onyx Winter Park, offering beautiful apartments close to Howell Branch Academy, Casselberry. Enjoy modern amenities and convenient school access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "page_item_url": "onyx-winter-park-apartments-near-park-maitland-preschool-334",
      "search_query": "apartments near Park Maitland Preschool FL",
      "category": "School",
      "h1_title": "Apartments Near Park Maitland Preschool",
      "h2_subtitle": "Live comfortably at Onyx Winter Park, featuring apartments conveniently located near Park Maitland Preschool in FL.",
      "page_copy": "Welcome to Onyx Winter Park, where you and your family can enjoy spacious living just a short distance from Park Maitland Preschool in FL. Our community offers well-designed studio and two-bedroom apartments that cater to both small families and educators. In addition to a range of floor plans, each apartment comes with high-speed internet and an array of modern, convenient appliances like a range and dishwasher.\n\nResidents of Onyx Winter Park benefit from an incredible mix of community amenities. Relax by Lake Howell, challenge yourself in the fitness center, or host fun gatherings in our vibrant clubhouse. The proximity to Park Maitland Preschool makes our location ideal for families seeking a blend of educational opportunity and relaxed living. Experience the best of both worlds at Onyx Winter Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with modern furniture and abstract art.",
        "public_id": "019f6c10-0b55-741d-b06f-ed490498fe09",
        "storage_key": "property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Park Maitland Preschool, FL",
      "seo_description": "Find your ideal home at Onyx Winter Park, offering modern apartments near Park Maitland Preschool, FL, with exciting amenities for families.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "page_item_url": "onyx-winter-park-apartments-near-geneva-school-casselberry-269",
      "search_query": "apartments close to The Geneva School Casselberry",
      "category": "School",
      "h1_title": "Apartments Close to The Geneva School",
      "h2_subtitle": "Discover convenient living at Onyx Winter Park with apartments close to The Geneva School in Casselberry.",
      "page_copy": "At Onyx Winter Park, enjoy the perfect blend of comfort and convenience with our apartments located near The Geneva School in Casselberry, FL. Our stylish studios and spacious two-bedroom floor plans cater to diverse lifestyles, making them ideal for students, educators, and families. Each apartment is equipped with high-speed internet and modern amenities such as a dishwasher and range, ensuring a comfortable living experience.\n\nOur community offers an array of amenities designed to enhance your lifestyle. Whether you wish to relax by Lake Howell, stay active at the fitness center, or host a gathering in our vibrant clubhouse, there are plenty of options. The proximity to The Geneva School makes Onyx Winter Park a great choice for those seeking quality education and a beautiful home environment in Casselberry.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with modern furniture and abstract art.",
        "public_id": "019f6c10-0b55-741d-b06f-ed490498fe09",
        "storage_key": "property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near The Geneva School, Casselberry",
      "seo_description": "Explore Onyx Winter Park, featuring modern apartments close to The Geneva School in Casselberry, FL, with excellent amenities for an enhanced lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "page_item_url": "onyx-winter-park-apartments-near-orange-county-preparatory-academy-83",
      "search_query": "apartments near Orange County Preparatory Academy",
      "category": "School",
      "h1_title": "Apartments Near Orange County Prep Academy",
      "h2_subtitle": "Find remarkable apartment living at Onyx Winter Park, conveniently near Orange County Preparatory Academy.",
      "page_copy": "Discover the joy of living at Onyx Winter Park, where our apartments are just a short drive from Orange County Preparatory Academy. Our community offers diverse floor plans that include studios and expansive two-bedroom options, perfectly suited for families, educators, and students. Each apartment is outfitted with high-speed internet and modern appliances like a dishwasher and range, ensuring a comfortable lifestyle.\n\nEnjoy an array of first-rate amenities at Onyx Winter Park, designed to cater to your lifestyle needs. Stay fit in our fully-equipped fitness center, socialize in the vibrant clubhouse, or relax in the serene picnic area by Lake Howell. The proximity to Orange County Preparatory Academy makes Onyx Winter Park a prime choice for those seeking both educational opportunities and an exceptional living experience in Casselberry, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with modern furniture and abstract art.",
        "public_id": "019f6c10-0b55-741d-b06f-ed490498fe09",
        "storage_key": "property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Orange County Prep Academy",
      "seo_description": "Explore Onyx Winter Park, offering modern apartments near Orange County Preparatory Academy with top amenities for comfortable and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "page_item_url": "onyx-winter-park-apartments-near-aloma-high-school-seminole-746",
      "search_query": "apartments close to Aloma High School Seminole County",
      "category": "School",
      "h1_title": "Apartments Close to Aloma High School",
      "h2_subtitle": "Experience quality apartment living near Aloma High School in Seminole County at Onyx Winter Park.",
      "page_copy": "Welcome to Onyx Winter Park, offering contemporary living with our apartments located conveniently close to Aloma High School in Seminole County. Ideal for families, teachers, and students, our community features a variety of thoughtfully designed floor plans, including studios and two-bedroom options. Modern conveniences such as high-speed internet and appliances like a dishwasher and range enhance your living experience.\n\nOnyx Winter Park is more than just a place to stay—it's a lifestyle. Take advantage of our robust community amenities by working out in the fitness center, enjoying the scenic views of Lake Howell, or gathering with friends in our lively clubhouse. The close proximity to Aloma High School makes this an excellent choice for those who prioritize both education and a vibrant lifestyle. Come explore Onyx Winter Park today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with modern furniture and abstract art.",
        "public_id": "019f6c10-0b55-741d-b06f-ed490498fe09",
        "storage_key": "property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Aloma High School, Seminole",
      "seo_description": "Find vibrant living at Onyx Winter Park, with modern apartments close to Aloma High School in Seminole County featuring top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "page_item_url": "onyx-winter-park-apartments-near-bishop-moore-catholic-high-709",
      "search_query": "apartments near Bishop Moore Catholic High School FL",
      "category": "School",
      "h1_title": "Apartments Near Bishop Moore Catholic High",
      "h2_subtitle": "Explore convenient living at Onyx Winter Park, with apartments near Bishop Moore Catholic High School in FL.",
      "page_copy": "At Onyx Winter Park, discover a home that combines style and convenience, ideally situated near Bishop Moore Catholic High School in FL. Whether you're a student, educator, or family member, our community offers versatile floor plans ranging from studios to spacious two-bedroom apartments, all designed to meet your lifestyle needs. With high-speed internet and modern amenities such as a dishwasher and range, you'll feel right at home.\n\nOur community at Onyx Winter Park boasts a variety of amenities to suit all interests. Relax by Lake Howell, stay fit in our well-equipped fitness center, or enjoy social gatherings in our vibrant clubhouse. The proximity to Bishop Moore Catholic High School makes our location an ideal choice for those prioritizing access to quality education and a superior living experience. Make Onyx Winter Park your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with modern furniture and abstract art.",
        "public_id": "019f6c10-0b55-741d-b06f-ed490498fe09",
        "storage_key": "property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bishop Moore Catholic High FL",
      "seo_description": "Discover Onyx Winter Park, featuring stylish apartments near Bishop Moore Catholic High School in FL, complemented by exceptional community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5712947535937536",
      "source": "custom",
      "page_item_url": "onyx-winter-park-apartments-near-lake-highland-prep-school-274",
      "search_query": "apartments close to Lake Highland Preparatory School",
      "category": "School",
      "h1_title": "Apartments Close to Lake Highland Prep School",
      "h2_subtitle": "Enjoy exceptional living at Onyx Winter Park, with apartments conveniently close to Lake Highland Preparatory School.",
      "page_copy": "Experience premier living at Onyx Winter Park, perfectly located just a short drive from Lake Highland Preparatory School. Our community offers a range of floor plans, from cozy studios to spacious two-bedroom options, designed to cater to families, educators, and students alike. Equipped with high-speed internet and modern kitchen appliances such as a range and dishwasher, our apartments provide all the comforts of home.\n\nAt Onyx Winter Park, you'll find outstanding amenities that complement your lifestyle. Enjoy workouts in the fitness center, unwind in our lively clubhouse, or have a peaceful day at the picnic area overlooking Lake Howell. Being close to Lake Highland Preparatory School means easy access to excellent educational opportunities without compromising on quality living. Discover the vibrant community and make Onyx Winter Park your next residence!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with modern furniture and abstract art.",
        "public_id": "019f6c10-0b55-741d-b06f-ed490498fe09",
        "storage_key": "property/5712947535937536/019f6c10-0b55-741d-b06f-ed490498fe09.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lake Highland Prep School",
      "seo_description": "Onyx Winter Park offers stylish, amenity-rich apartments close to Lake Highland Preparatory School, perfect for families and professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2181"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376471095"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a3d\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a3d\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4680438"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NWZCCZT"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://onyxwinter.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443838466"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/960p7lydv7n"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/3f776e40-92d1-40cb-a75e-0ad09f11199e"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "321-238-8709"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjQxREhjTEx1b0I2dUtEczZnMG5JaFE9PSIsInZhbHVlIjoiMktlR3V4UnM4OVFKbFR1QjFBUkMvZz09IiwibWFjIjoiNjAwNTM4MGZmZTU5MTg3ZTMyN2Y3MjE2ZTVjMDcwYmM5NDBlZjhjOTZlYWI5NzcyMjYxZjhmN2FmYzY3ODQ1YiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2181",
  "custom_repli_id": "2376471095",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a3d\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a3d\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4680438",
  "custom_google_gtm_id": "GTM-NWZCCZT",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "full_stack",
  "custom_betterbot_script": "<script src=\"https://onyxwinter.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443838466",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/960p7lydv7n",
  "custom_self_guided_tour_url": "https://selftournow.com/property/3f776e40-92d1-40cb-a75e-0ad09f11199e",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "321-238-8709",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjQxREhjTEx1b0I2dUtEczZnMG5JaFE9PSIsInZhbHVlIjoiMktlR3V4UnM4OVFKbFR1QjFBUkMvZz09IiwibWFjIjoiNjAwNTM4MGZmZTU5MTg3ZTMyN2Y3MjE2ZTVjMDcwYmM5NDBlZjhjOTZlYWI5NzcyMjYxZjhmN2FmYzY3ODQ1YiJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-10-09T16:38:00.765Z';
